/* ============================================================
   MAGNUMASTER — theme behaviour
   ------------------------------------------------------------
   Every block is guarded so the same file is safe on every template
   (home has the hero, marquee and size guide; subpages do not).

   Generated from js/main.js by scripts/build-theme.js. After the
   cutover this file is the source of truth — edit it here.

   Everything it needs about the shop was rendered into the page by
   snippets/mm-catalog.liquid: window.MM_SHOP (catalogue, variant ids,
   live prices, shipping list, bank-transfer offer), window.MM_CART
   (the cart as Shopify has it right now) and window.MM_DICT_URLS.
   There is no Storefront API call, no access token and no fallback
   price list, because there is nothing left to fall back from.
   ============================================================ */
(function(){
  "use strict";

  /* ---- i18n core (declared early: the configurator and cart paint before
     the language switcher is built, and both translate their labels) ---- */
  var LANG_KEY = 'mm_lang';
  var LANGS = ['en','de','it','es','fr','pt','nl'];
  // Loaded dictionaries, keyed by lang code. `en` is seeded from the markup
  // itself (every [data-i18n] ships with its English text inline), so the page
  // is never blank and English needs no network request at all.
  // Strings rendered by JS have no markup to seed from, and some of them paint
  // before seedEnglish() runs — so the English originals live here.
  var DICT = { en: {
    'js.openingCheckout': 'Opening secure checkout…',
    'js.exclVat': 'excl. VAT &amp; shipping',
    'js.fillFields': 'Please fill in the highlighted fields.',
    'js.sending': 'Sending…',
    'js.cartEmpty': 'Your cart is empty.',
    'js.exclVatEach': 'excl. VAT each',
    'js.remove': 'Remove',
    'js.addedToast': '{name} added to cart &nbsp;·&nbsp; <a href="{url}">View cart &rarr;</a>',
    'js.customFinish': 'custom finish',
    'js.engraving': 'Personalised engraving',
    'js.included': 'Included',
    'js.coating': 'Custom powder-coating',
    'js.noQuickMatch': 'No quick match for “{q}” —',
    'js.searchAll': 'search the whole store',
    'aria.dismiss': 'Dismiss',
    'nav.cart': 'Cart',
    'menu.language': 'Language',
    'pay.bank.badge': 'Save {pct}%',
    'pay.bank.headline': 'Pay by bank transfer and save {pct}%.',
    'pay.bank.body': 'Choose <b>Bank transfer</b> at checkout. We send the invoice with our bank details and dispatch as soon as the payment clears.',
    'pay.bank.code': '<b>No discount code needed.</b> Once your order is confirmed we send the invoice with the {pct}% already deducted — pay that amount.',
    'pay.bank.save': 'That is {amount} off this order.',
    'ship.other': 'Another country — not listed',
    'ship.pick': 'Please choose…',
    'ship.warn.lead': 'We cannot ship to {country} through the online shop.',
    'ship.warn.body': 'Your destination is not on our carrier’s rate card, so the checkout has no delivery price for it. Tell us where the cradle is going and we will quote the shipping, then send you an invoice you can pay directly.',
    'ship.warn.cta': 'Request a shipping quote',
    'ship.warn.toast': 'We cannot ship to {country} through the online shop. <a href="/pages/request-a-quote">Request a quote</a> and we will price the delivery.',
    'post.read': 'Read the article',
    'post.all': 'All articles'
  } };
  var curLang = 'en';

  // The language on screen right now — what the checkout and the quote form
  // should be tagged with. Not the stored preference: on a first visit the
  // country lookup can move us off it.
  function getLang(){ return curLang; }

  // An explicit click on the switcher, and nothing else. A country guess is
  // deliberately never written here, so we can always tell "the visitor chose
  // this" from "we guessed this" on the next page load.
  function chosenLang(){
    try{
      var l = localStorage.getItem(LANG_KEY);
      if(LANGS.indexOf(l) >= 0) return l;
    }catch(e){}
    return null;
  }

  function browserLang(){
    var nav = (navigator.language || 'en').slice(0,2).toLowerCase();
    return LANGS.indexOf(nav) >= 0 ? nav : null;
  }

  /* ---- country → language -------------------------------------------------
     The static site read the visitor's country from Cloudflare's
     /cdn-cgi/trace, which existed because Cloudflare fronted the site.
     Shopify does not serve that path. It does serve
     /browsing_context_suggestions.json, which is its own detection of
     the visitor's country and language — same origin, no key, no third
     party, and it is what Shopify's country selector uses.

     It still has to happen in the browser rather than as a redirect:
     the HTML is edge-cached, so a redirect decided server-side would be
     cached and then served to every other country too.

     Only countries where one of our seven languages is clearly dominant
     are listed; everywhere else falls through to English. */
  var GEO_LANG = {
    DE:'de', AT:'de', CH:'de', LI:'de',              // CH is multilingual; German is the majority
    IT:'it', SM:'it', VA:'it',
    FR:'fr', MC:'fr', LU:'fr',
    NL:'nl', BE:'nl', SR:'nl',                       // BE is majority Dutch; Wallonia can switch to FR
    PT:'pt', BR:'pt', AO:'pt', MZ:'pt', CV:'pt',
    ES:'es', MX:'es', AR:'es', CO:'es', CL:'es', PE:'es', VE:'es', EC:'es',
    GT:'es', CU:'es', BO:'es', DO:'es', HN:'es', PY:'es', SV:'es', NI:'es',
    CR:'es', PA:'es', UY:'es', PR:'es'
  };
  var GEO_KEY = 'mm_geo';

  // Cached per tab session, so only the first page view spends a request.
  function country(){
    try{
      var c = sessionStorage.getItem(GEO_KEY);
      if(c) return Promise.resolve(c === '-' ? null : c);
    }catch(e){}
    return fetch('/browsing_context_suggestions.json', {credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(d){
        var v = d && d.detected_values && d.detected_values.country;
        var c = v && v.handle ? String(v.handle).toUpperCase() : null;
        if(c && !/^[A-Z]{2}$/.test(c)) c = null;
        try{ sessionStorage.setItem(GEO_KEY, c || '-'); }catch(e){}
        return c;
      })
      .catch(function(){ return null; });   // no geo → we keep the browser's guess
  }

  /* ---- marketing attribution ----------------------------------------------
     An ad click lands on a static page that Shopify never sees until checkout,
     so the campaign that drove a sale is lost unless we carry it ourselves. We
     read utm_* and the click IDs (fbclid/gclid) from the visit's FIRST page,
     keep them for the tab session, and stamp them onto the Shopify cart and any
     quote — so the order in the admin shows where it came from.
     First-touch: a later page with no params never wipes what the ad set, but a
     fresh ad click in the same tab (new utm_*) does overwrite. */
  var ATTR_KEY = 'mm_attribution';
  var ATTR_FIELDS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'];
  function attribution(){
    try{ return JSON.parse(sessionStorage.getItem(ATTR_KEY)) || {}; }catch(e){ return {}; }
  }
  function captureAttribution(){
    var stored = attribution();
    var p = new URLSearchParams(window.location.search);
    var sawNew = false;
    ATTR_FIELDS.forEach(function(k){
      var v = p.get(k);
      if(v){ stored[k] = v.slice(0, 500); sawNew = true; }
    });
    // Record the landing context once, with the first params we see.
    if(sawNew && !stored.landing_page){
      stored.landing_page = (location.pathname + location.search).slice(0, 500);
      if(document.referrer) stored.referrer = document.referrer.slice(0, 500);
    }
    if(sawNew){ try{ sessionStorage.setItem(ATTR_KEY, JSON.stringify(stored)); }catch(e){} }
  }
  captureAttribution();

  // Seed English from the markup so the first paint needs no network round-trip.
  // Empty nodes are skipped — a JS-rendered element that painted before its key
  // was known would otherwise cache "" and stay blank forever.
  function seedEnglish(){
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var k = el.getAttribute('data-i18n'), v = el.innerHTML;
      if(v !== '' && DICT.en[k] === undefined) DICT.en[k] = v;
    });
  }

  /* ---- where the text comes from ------------------------------------------
     Two sources, in order of preference:

       1. the CMS, if js/cms-config.js switched it on — so a client's edit is
          live without a deployment;
       2. i18n/<lang>.json, shipped with the site.

     (2) is always present and is what the site used before the CMS existed.
     The CMS is a nicety layered on top: if it is slow, down, or off, the
     fetch is abandoned and the shipped file is used instead. A visitor never
     waits on it and never sees an error. The shop must be able to sell with
     the CMS switched off. */
  var CMS = window.MM_CMS || {};
  var CMS_CACHE_KEY = 'mm_cms_dict_';

  // A dictionary we fetched recently, so page-to-page navigation does not
  // re-request it. sessionStorage, so it is dropped when the tab closes.
  function cmsCached(lang){
    if(!CMS.cacheMinutes) return null;
    try{
      var raw = sessionStorage.getItem(CMS_CACHE_KEY + lang);
      if(!raw) return null;
      var v = JSON.parse(raw);
      if(Date.now() - v.at > CMS.cacheMinutes * 60000) return null;
      return v.dict;
    }catch(e){ return null; }
  }
  function cmsRemember(lang, dict){
    if(!CMS.cacheMinutes) return;
    try{ sessionStorage.setItem(CMS_CACHE_KEY + lang, JSON.stringify({at:Date.now(), dict:dict})); }
    catch(e){ /* quota or private mode — we simply refetch next time */ }
  }

  function fetchFromCms(lang){
    if(!CMS.enabled || !CMS.api) return Promise.reject(new Error('cms off'));

    var hit = cmsCached(lang);
    if(hit) return Promise.resolve(hit);

    // AbortController so a hanging CMS cannot hold the page. Older browsers
    // without it simply skip the CMS and use the shipped file.
    if(typeof AbortController !== 'function') return Promise.reject(new Error('no abort'));
    var ctrl = new AbortController();
    var timer = setTimeout(function(){ ctrl.abort(); }, CMS.timeout || 2500);

    return fetch(CMS.api + '/content/' + lang, {signal: ctrl.signal, credentials: 'omit'})
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(d){
        if(!d || typeof d !== 'object' || Array.isArray(d)) throw new Error('bad payload');
        // An empty or near-empty response means something is wrong at the CMS
        // end. Refuse it rather than blanking the site.
        if(Object.keys(d).length < 50) throw new Error('suspiciously small dictionary');
        cmsRemember(lang, d);
        return d;
      })
      .finally(function(){ clearTimeout(timer); });
  }

  /* The shipped dictionaries. Theme asset URLs carry a ?v= cache key
     that changes with the file, so the path cannot be built by
     concatenation — Liquid hands us the finished list instead. */
  function fetchStatic(lang){
    var url = (window.MM_DICT_URLS || {})[lang];
    if(!url) return Promise.reject(new Error('no dictionary URL for ' + lang));
    return fetch(url)
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); });
  }

  /* ---- pictures the client has replaced -------------------------------------
     Same contract as the dictionary: the CMS is an *override*, the markup is
     the truth. Every <img> already carries its own src, so a site whose CMS is
     off, slow or empty shows exactly the pictures it was built with — there is
     no shipped images.json to keep in step and nothing to go stale.

     Keyed on that original src, which is why replacing a picture needed no
     change to any of the 224 <img> tags. Publishing later rewrites the src in
     the HTML and leaves a data-img="<original>" behind, so the key survives
     the rewrite and the picture can still be reverted afterwards. */
  function applyImages(){
    if(!CMS.enabled || !CMS.api) return Promise.resolve();
    if(typeof AbortController !== 'function') return Promise.resolve();

    var ctrl = new AbortController();
    var timer = setTimeout(function(){ ctrl.abort(); }, CMS.timeout || 2500);

    return fetch(CMS.api + '/images', {signal: ctrl.signal, credentials: 'omit'})
      .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(d){
        var map = d && d.images;
        if(!map || typeof map !== 'object') return;

        // "./assets/x.png", "/assets/x.png" and "assets/x.png?v=2" are one key.
        function keyOf(el){
          var k = el.getAttribute('data-img');
          if(k) return k;
          var raw = el.getAttribute('src') || el.getAttribute('srcset') || '';
          raw = raw.split(',')[0].trim().split(/\s+/)[0];
          return raw.replace(/^\.?\//, '').split('?')[0];
        }

        document.querySelectorAll('img, source').forEach(function(el){
          var hit = map[keyOf(el)];
          if(!hit || !hit.url) return;
          if(el.tagName === 'SOURCE') el.setAttribute('srcset', hit.url);
          else el.setAttribute('src', hit.url);
          // Alt is content: only replace it when the CMS actually carries one.
          if(hit.alt && el.tagName === 'IMG') el.setAttribute('alt', hit.alt);
        });
      })
      .catch(function(){ /* CMS off, slow or unreachable — keep the originals */ })
      .finally(function(){ clearTimeout(timer); });
  }

  var loaded = {};

  /* The shipped dictionary is the BASE layer; the CMS is an override laid on
     top of it. Both are fetched, because neither one alone is enough:

       - The CMS is where the client edits copy, so it has to win wherever it
         carries a value.
       - The CMS only knows the keys that were imported into it. A key added in
         this repo does not exist there until `node scripts/import-i18n.js` has
         been run in the CMS repo — and while the CMS answered *instead of* the
         shipped file, every such key fell back to English in all five
         languages. That is why a translated page could still show one English
         sentence for weeks.

     Fetching both makes a new key translate the moment it ships, and keeps the
     property the shop depends on: with the CMS off, slow, empty or
     unreachable, the site is still fully translated from the files in this
     repo. */
  function loadDict(lang){
    if(loaded[lang]) return Promise.resolve(DICT[lang]);
    // English is the exception, and gains nothing from the layering: the
    // markup IS the English original and the DICT.en block above carries the
    // strings JS renders, so a key the CMS has never heard of is already
    // right on screen. It keeps the single request it always made.
    var base = lang === 'en'
      ? Promise.resolve(null)
      : fetchStatic(lang).catch(function(){ return null; });
    var over = fetchFromCms(lang).catch(function(){ return null; });
    return Promise.all([base, over])
      .then(function(r){
        if(!r[0] && !r[1]) return fetchStatic(lang).then(function(d){ return [d, null]; });
        return r;
      })
      .then(function(r){
        // en.json is authoritative — it also carries the JS-only strings that
        // never appear in markup, so merge rather than replace the seed.
        DICT[lang] = Object.assign(DICT[lang] || {}, r[0] || {});
        // An empty value in the CMS is "not translated", not "translate to
        // nothing" — it must not blank out the shipped translation.
        var cms = r[1] || {};
        for(var k in cms) if(cms[k] !== '' && cms[k] != null) DICT[lang][k] = cms[k];
        loaded[lang] = true;
        return DICT[lang];
      })
      .catch(function(){ DICT[lang] = DICT[lang] || {}; return DICT[lang]; });  // fall back to English
  }

  function setLang(lang){
    if(LANGS.indexOf(lang) < 0) lang = 'en';
    try{ localStorage.setItem(LANG_KEY, lang); }catch(e){}
    applyLang(lang);
  }

  // Translate one string by key, falling back to English when a language is
  // only partially translated. Exposed so JS-generated markup can use it.
  function t(key){
    var d = DICT[curLang];
    if(d && d[key] !== undefined && d[key] !== '') return d[key];
    return DICT.en[key] !== undefined ? DICT.en[key] : '';
  }

  function paint(lang){
    curLang = lang;
    document.documentElement.lang = lang;
    // Kept so the handful of legacy `body.is-de` CSS hooks still fire.
    document.body.classList.toggle('is-de', lang === 'de');
    document.body.setAttribute('data-lang', lang);
    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var v = t(el.getAttribute('data-i18n'));
      if(v !== '' && el.innerHTML !== v) el.innerHTML = v;
    });
    // Attribute translations: data-i18n-attr="placeholder:KEY, aria-label:KEY"
    document.querySelectorAll('[data-i18n-attr]').forEach(function(el){
      el.getAttribute('data-i18n-attr').split(',').forEach(function(part){
        var bits = part.split(':');
        if(bits.length !== 2) return;
        var v = t(bits[1].trim());
        if(v !== '') el.setAttribute(bits[0].trim(), v.replace(/<[^>]*>/g, ''));
      });
    });
    document.querySelectorAll('.lang-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-lang') === lang);
    });
    // The consent banner carries its own copy of the seven languages and paints
    // before we do, so it needs telling when the language moves under it.
    if(window.MM_CONSENT && MM_CONSENT.relang) MM_CONSENT.relang(lang);
    // Blocks the loop above cannot reach: their markup is generated by JS, so
    // there are no [data-i18n] nodes to repaint — they have to be rebuilt. Both
    // are no-ops off the cart page. Guarded because paint() also runs during
    // the very first applyLang(), before the store section has had a chance to
    // read the cart.
    try{ paintBankNote(); paintShipGate(); }catch(e){}
    // The configurator's price breakdown is built by JS too ("Personalised
    // engraving · Included"), so it stayed in whatever language painted first.
    try{ configRoots.forEach(paintConfig); }catch(e){}
    if(typeof update === 'function') update();
  }

  function applyLang(lang){
    // Paint immediately from what we already have (markup seed / inline
    // defaults), then repaint once the full dictionary lands.
    paint(lang);
    return loadDict(lang).then(function(){ paint(lang); });
  }
  // Let other scripts (and JS-rendered markup) translate and re-render.
  window.MM_I18N = { t:t, lang:function(){ return curLang; }, set:setLang, repaint:function(){ paint(curLang); } };
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- catalog -------------------------------------------------------------
     Rendered into the page by snippets/mm-catalog.liquid, from the products
     themselves. There is no fallback price list because there is no request
     that could fail: if Shopify can serve this page, it has already told us
     what everything costs. Declared early — the home-page size guide paints
     before the store section runs. */
  var SHOP = window.MM_SHOP || {};
  var ROUTES = SHOP.routes || {root:'/', cart:'/cart', cartAdd:'/cart/add', cartChange:'/cart/change', cartUpdate:'/cart/update', checkout:'/checkout', shop:'/collections/all', quote:'/pages/request-a-quote', blog:'/blogs/journal'};
  var CURRENCY = SHOP.currency || 'EUR';
  var CATALOG = SHOP.catalog || {};
  // Kept for the few places that still speak of one surcharge; the real
  // figure is per model and derived from the two variants' prices.
  var COATING_PRICE = (CATALOG.XL && CATALOG.XL.coatingSurcharge) || 0;
  function coatingOf(code){
    var c = CATALOG[code];
    return c && typeof c.coatingSurcharge === 'number' ? c.coatingSurcharge : COATING_PRICE;
  }

  /* Analytics bridge. analytics.js owns the vendor APIs; if it is blocked
     or still loading, tracking must never take the shop down with it. */
  function track(event, payload){
    try{ if(window.MM_TRACK && MM_TRACK[event]) MM_TRACK[event](payload); }
    catch(e){ if(window.console) console.warn('track failed', e); }
  }
  /* Money, in major units. Kept identical to what the site printed before:
     whole euros for round prices, cents only when they exist. */
  var MONEY_SYMBOL = { EUR:'€', USD:'$', GBP:'£', CHF:'CHF ' };
  function euro(n){
    var sym = MONEY_SYMBOL[CURRENCY] || (CURRENCY + ' ');
    var v = Number(n) || 0;
    var frac = Math.abs(v % 1) > 0.005 ? 2 : 0;
    return sym + v.toLocaleString('en-US', {minimumFractionDigits:frac, maximumFractionDigits:frac});
  }
  // Shopify quotes every price in the currency's minor unit.
  function money(cents){ return euro((Number(cents) || 0) / 100); }

  // Re-render everything that shows a price, after a Shopify catalog sync.
  var repaintHooks = [];
  var configRoots = [];

  /* ---- reveal on scroll ---- */
  var revs = document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var d = e.target.getAttribute('data-delay');
          if(d) e.target.style.transitionDelay = d+'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.14, rootMargin:'0px 0px -8% 0px'});
    revs.forEach(function(el){io.observe(el);});
  } else { revs.forEach(function(el){el.classList.add('in');}); }

  /* ---- lazy videos: fetch only once in view, then autoplay ----
     These are heavy files sitting below the fold. Loading them eagerly starved
     the hero video of bandwidth on mobile. The poster carries the section until
     the file arrives, and playback is best-effort: a phone refusing autoplay
     still leaves a working <video controls>. */
  var lazyVids = document.querySelectorAll('[data-lazy-video]');
  if(lazyVids.length){
    var loadVid = function(v){
      if(v.src) return;
      // The URL is a theme setting now, so it can legitimately be empty.
      // Assigning '' to src would make the browser re-request the page
      // itself as a video; leave the poster in place instead.
      var src = v.getAttribute('data-lazy-video');
      if(!src) return;
      v.src = src;
      var p = v.play();
      if(p && p.catch) p.catch(function(){ /* autoplay blocked — controls remain */ });
    };
    if('IntersectionObserver' in window){
      var vio = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          loadVid(e.target);
          vio.unobserve(e.target);
        });
      },{rootMargin:'200px 0px'});     // a touch early, so it is ready on arrival
      lazyVids.forEach(function(v){ vio.observe(v); });
    } else { lazyVids.forEach(loadVid); }
  }

  /* ---- hero line reveal on load (home only) ---- */
  var hero = document.getElementById('hero');
  if(hero){
    window.addEventListener('load', function(){
      requestAnimationFrame(function(){ hero.classList.add('in'); });
    });
    setTimeout(function(){ hero.classList.add('in'); }, 600);
  }

  /* ---- scroll progress + nav state + buybar + parallax + pour scrub ---- */
  var progress = document.getElementById('progress');
  var masthead = document.getElementById('masthead');
  var buybar = document.getElementById('buybar');
  var heroVid = document.querySelector('.hero__video');
  if(heroVid){ heroVid.playbackRate = 0.6; heroVid.addEventListener('loadedmetadata', function(){ heroVid.playbackRate = 0.6; }); var _vp = heroVid.play(); if(_vp && _vp.catch){ _vp.catch(function(){}); } }
  var parallax = document.querySelectorAll('[data-parallax]');
  // solid mastheads (subpages) keep the scrolled look at all times
  var alwaysSolid = masthead && masthead.classList.contains('masthead--solid');
  var ticking = false;

  /* Publish the fixed header's height so sticky sections can pin *below* it
     instead of sliding underneath. Solid mastheads never collapse their utility
     strip, so this height is stable between resizes. */
  var mastH = 0;
  function setMastH(){
    mastH = masthead ? masthead.offsetHeight : 0;
    document.documentElement.style.setProperty('--mast-h', mastH + 'px');
  }
  setMastH();
  window.addEventListener('resize', setMastH);
  window.addEventListener('load', setMastH);

  /* ---- pour scroll-scrub controller (Engineering section) ---- */
  var pour = document.querySelector('.pour');
  var pourRail = pour ? pour.querySelector('.pour__rail') : null;
  var pourSteps = pour ? pour.querySelectorAll('.pour__step') : [];
  var pourDots = pour ? pour.querySelectorAll('.pour__dots b') : [];
  var pourPct = pour ? pour.querySelector('.pour__pct') : null;
  var pourFrame = document.getElementById('pourFrame');
  var pourActive = -1;
  var pourFrameIdx = -1;

  /* Phones play a looping clip of the pour instead of scrubbing frames
     (client, 17.09.2026: the scrub "doesn't work on mobile" — use the video,
     in an infinite loop). The copy beside it still steps through the six
     principles with scroll; only the picture stops depending on it, so the
     frames are never downloaded on a phone at all. The clip is 270 KB against
     the frames' ~550 KB. Decided once at boot: a phone rotating to landscape
     stays under the breakpoint, and swapping modes mid-visit would restart it.
     Reduced motion keeps the single still frame, as before. */
  var pourLoop = pour ? pour.querySelector('.pour__loop') : null;
  var pourLoopOn = !!(pourLoop && pourLoop.getAttribute('data-src') && !reduce &&
    window.matchMedia && window.matchMedia('(max-width:939px)').matches);

  // Build the frame list, and warm it (below) before the section arrives so
  // scrubbing is flicker-free.
  // The preloaded Image objects are kept, not thrown away: on a phone the
  // visitor can scroll into the section before all 23 frames have arrived, and
  // assigning .src to a frame that has not downloaded yet paints *nothing* —
  // the animation appears to break. Holding the objects lets the scrub check
  // whether a frame is actually ready and keep showing the last good one if not.
  var pourFrames = [];
  var pourImgs = [];
  if(pour && pourFrame){
    /* The frame URLs. The static site built them by concatenation from a
       base path; a theme asset URL carries a ?v= cache key, so Liquid
       hands over the finished list in data-frame-urls instead. The old
       concatenation stays as the fallback for a section that does not. */
    var listed = [];
    try{ listed = JSON.parse(pour.getAttribute('data-frame-urls') || '[]'); }catch(e){ listed = []; }
    var total = listed.length || parseInt(pour.getAttribute('data-frames'), 10) || 0;
    var base = pour.getAttribute('data-frame-base') || 'assets/pour/f-';
    var ext = pour.getAttribute('data-frame-ext') || '.jpg';
    for(var fi=1; fi<=total; fi++){
      var n = (fi<100 ? (fi<10 ? '00'+fi : '0'+fi) : ''+fi);
      var url = listed[fi-1] || (base + n + ext);
      pourFrames.push(url);
    }

    /* Warming them is ~550 KB, and this section is three screens below the
       fold. Doing it at boot meant the hero video, the stylesheet, the fonts
       and the poster all queued behind an animation nobody had scrolled to
       yet. Start before the section arrives instead: far enough ahead that
       the frames are ready when it does, and a visitor who never reaches it
       never pays for them at all. Reduced motion never scrubs —
       pour--static shows the one frame below — so it never warms.

       The lead used to be 150% of a viewport, which on a 700px phone is
       barely 1.000px of scrolling: two seconds at a normal flick, against
       three or four to pull 550 KB down a mobile connection. So the scrub
       began with most frames still in flight and every one of them was
       skipped by the readiness check below. That is the client's "doesn't
       move at all on mobile" (07.09.2026) — on a desktop connection the same
       code has its frames long before the section is on screen, which is why
       it only ever showed up on a phone. 300% roughly doubles the head start
       and still downloads nothing during the first paint, which is the rule
       that actually matters (see CLAUDE.md).

       onload matters as much as the lead does. A visitor who scrolls in,
       stops and waits generates no further scroll events, so a frame landing
       a moment later would never be painted — the animation would sit frozen
       on whatever happened to arrive first. Each frame therefore re-runs the
       scrub as it lands, and refreshPour() is a no-op unless the section is
       on screen. */
    var pourWarmed = reduce || pourLoopOn;
    var warmPour = function(){
      if(pourWarmed) return;
      pourWarmed = true;
      for(var wi=0; wi<pourFrames.length; wi++){
        var im = new Image();
        im.decoding = 'async';
        im.onload = refreshPour;
        im.src = pourFrames[wi];          // warm the cache
        pourImgs[wi] = im;
      }
    };
    if('IntersectionObserver' in window){
      var pourIo = new IntersectionObserver(function(entries){
        for(var ei=0; ei<entries.length; ei++){
          if(!entries[ei].isIntersecting) continue;
          pourIo.disconnect();
          warmPour();
          return;
        }
      }, {rootMargin:'300% 0px'});
      pourIo.observe(pour);
    } else {
      window.addEventListener('load', warmPour);
    }
  }
  // if motion is reduced, fall back to a plain stacked section (no pin/scrub)
  if(pour && reduce){ pour.classList.add('pour--static'); }

  /* The loop, on a phone. Nothing is fetched at boot (preload="none", no src
     in the markup): the src is assigned with the same 300% lead the frames
     use, and the clip only plays while the section is on screen. First frame
     of the scrub stays underneath until 'playing', so a slow start or an
     autoplay refusal (iOS Low Power Mode) shows the still, never a black box.
     If the file cannot play at all, fall back to the scrub. */
  if(pourLoopOn){
    pour.classList.add('pour--loop');
    var loopLoaded = false, loopVisible = false;
    var loadLoop = function(){
      if(loopLoaded) return;
      loopLoaded = true;
      pourLoop.preload = 'auto';
      pourLoop.src = pourLoop.getAttribute('data-src');
    };
    var playLoop = function(){
      loadLoop();
      var pr = pourLoop.play();
      if(pr && pr.catch) pr.catch(function(){});
    };
    pourLoop.addEventListener('playing', function(){ pourLoop.classList.add('is-playing'); });
    pourLoop.addEventListener('error', function(){
      pourLoopOn = false;
      pour.classList.remove('pour--loop');
      pourWarmed = false;
      if(warmPour) warmPour();
      updatePour();
    });
    // an autoplay refusal is lifted by a gesture; retry on the next touch
    document.addEventListener('touchstart', function(){
      if(pourLoopOn && loopVisible && pourLoop.paused) playLoop();
    }, {passive:true});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        if(entries[0].isIntersecting) loadLoop();
      }, {rootMargin:'300% 0px'}).observe(pour);
      new IntersectionObserver(function(entries){
        loopVisible = entries[0].isIntersecting;
        if(!pourLoopOn) return;
        if(loopVisible) playLoop(); else pourLoop.pause();
      }).observe(pourLoop);
    } else {
      window.addEventListener('load', function(){ loopVisible = true; playLoop(); });
    }
  }

  var pourStage = pour ? pour.querySelector('.pour__stage') : null;

  /* An Image that has not started, or is still in flight, has complete=false;
     one that failed has complete=true and naturalWidth 0, and painting that
     would blank the frame, so it does not count as ready either. A slot with
     no Image at all means warmPour has not run yet — the section is nowhere
     near the screen — and the browser can be left to fetch it on demand. */
  function pourReady(i){
    var im = pourImgs[i];
    if(!im) return true;
    return im.complete && im.naturalWidth > 0;
  }

  /* The frame we want, or the closest one either side of it that has arrived.
     Ties go forwards, so a scrub running ahead of the download still advances
     rather than stepping back. -1 means nothing has landed yet. */
  function nearestReady(i){
    if(pourReady(i)) return i;
    for(var d=1; d<pourFrames.length; d++){
      if(i+d < pourFrames.length && pourReady(i+d)) return i+d;
      if(i-d >= 0 && pourReady(i-d)) return i-d;
    }
    return -1;
  }

  /* Called by each frame as it finishes downloading. Re-scrubs only while the
     section is on screen: off screen there is nothing to repaint, and this
     fires once per frame in the space of a couple of seconds.

     Through rAF, not straight in the load callback. updatePour() measures and
     then writes, and a measurement taken in the middle of a download callback
     forces its own layout — the same rule onScroll() is built around. A frame
     is the right place for it, and a handful of landings in the same frame
     collapse into one pass. */
  var refreshQueued = false;
  function refreshPour(){
    if(!pour || refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(function(){
      refreshQueued = false;
      var r = pour.getBoundingClientRect();
      if(r.bottom < 0 || r.top > window.innerHeight) return;
      updatePour();
    });
  }

  /* Split in two on purpose: readPour() only measures, writePour() only
     writes. See the note on onScroll() — every measurement in a frame has to
     happen before the first style change, or the browser re-runs layout in
     the middle of the frame. */
  function readPour(){
    if(!pour || !pourRail || pour.classList.contains('pour--static')) return null;
    return {
      top: pourRail.getBoundingClientRect().top,
      // Measure the stage, not window.innerHeight: the stage is sized in svh and on
      // mobile innerHeight shifts as the URL bar collapses. Using the element keeps
      // the scrub progress locked to what is actually pinned on screen.
      stageH: pourStage ? pourStage.offsetHeight : window.innerHeight,
      railH: pourRail.offsetHeight
    };
  }

  function updatePour(g){
    if(g === undefined) g = readPour();
    if(!g) return;
    // The stage pins at --mast-h (below the fixed header), not at 0, so the rail
    // is that much shorter in usable travel and progress starts when the rail top
    // reaches the header — not the viewport top.
    var travel = g.railH - g.stageH - mastH;
    var p = travel > 0 ? ((mastH - g.top) / travel) : 0;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);
    pour.style.setProperty('--p', p.toFixed(4));
    if(pourPct) pourPct.textContent = Math.round(p*100) + '%';

    // scrub the animation frame to scroll position
    if(pourFrame && pourFrames.length && !pourLoopOn){
      var fIdx = Math.round(p * (pourFrames.length - 1));
      if(fIdx < 0) fIdx = 0; if(fIdx > pourFrames.length-1) fIdx = pourFrames.length-1;
      /* Only swap to a frame that has actually arrived: assigning .src to one
         that has not downloaded yet paints nothing, and the animation looks
         broken.

         What this used to do when the wanted frame was not ready was hold the
         one already on screen. That is right for a single missing frame and
         wrong for the case a phone actually hits, which is a whole run of them
         missing at once — it then holds the *same* frame through the entire
         run, so the pour stops dead instead of degrading. Walk outwards to the
         nearest frame that is ready instead: the animation keeps moving, at a
         coarser step, and closes back up to full smoothness as the rest land.
         Only when nothing at all has arrived is the current frame kept, which
         is the first moment of the section and nothing else. */
      var want = nearestReady(fIdx);
      if(want >= 0 && want !== pourFrameIdx){
        pourFrameIdx = want;
        pourFrame.src = pourFrames[want];
      }
    }

    if(pourSteps.length){
      var idx = Math.floor(p * pourSteps.length);
      if(idx >= pourSteps.length) idx = pourSteps.length - 1;
      if(idx !== pourActive){
        pourActive = idx;
        for(var i=0;i<pourSteps.length;i++){ pourSteps[i].classList.toggle('is-active', i===idx); }
        for(var j=0;j<pourDots.length;j++){ pourDots[j].classList.toggle('on', j===idx); }
      }
    }
  }
  if(pourSteps.length){ pourSteps[0].classList.add('is-active'); if(pourDots.length) pourDots[0].classList.add('on'); pourActive = 0; }

  var wasScrolled = false;
  var barShown = false;
  var contactEl = document.getElementById('contact');

  /* ---- one layout per frame, not one per element -------------------------
     This used to interleave reads and writes: measure a parallax element,
     set its transform, measure the next one — and each measurement after a
     write makes the browser re-run layout *synchronously* before it can
     answer. With a parallax list, a rail and a buy-bar in the same handler
     that is a forced reflow several times per scroll frame, on a page of
     1.166 elements.

     It showed up in the field as `mm-theme.js: 357 ms of CPU, 18 ms of
     script evaluation` — almost none of it was running JavaScript, it was
     the layout our own reads were forcing. So: every measurement happens
     first, in the read phase, and nothing is written until all of them are
     done. Keep it that way — a single getBoundingClientRect() moved below a
     style assignment puts the whole cost back. */
  function onScroll(){
    /* ---- read phase: measure everything, change nothing ---- */
    var st = window.pageYOffset || document.documentElement.scrollTop;
    var vh = window.innerHeight;
    var trackH = progress ? (document.documentElement.scrollHeight - vh) : 0;
    var contactTop = (buybar && contactEl) ? contactEl.getBoundingClientRect().top : 99999;
    var pRects = null;
    if(!reduce && parallax.length){
      pRects = [];
      for(var pi = 0; pi < parallax.length; pi++) pRects.push(parallax[pi].getBoundingClientRect());
    }
    var pourGeom = readPour();

    /* ---- write phase: no measuring past this line ---- */
    if(progress) progress.style.width = (trackH > 0 ? (st/trackH*100) : 0) + '%';

    if(masthead && !alwaysSolid){
      var trigger = hero ? vh*0.72 : 40;
      // The utility strip collapses with .scrolled, so the header is a different
      // height either side of this line — and the pinned pour stage offsets
      // itself by --mast-h. Re-measure on the transition only; reading
      // offsetHeight every frame would force a layout on every scroll.
      if(masthead.classList.toggle('scrolled', st > trigger) !== wasScrolled){
        wasScrolled = !wasScrolled;
        setMastH();
      }
    }

    // buybar: show after first viewport, hide once we're deep in collection/contact
    if(buybar){
      var wantBar = st > vh*0.9 && contactTop > vh*0.4;
      // Only touch the classes when the answer actually changes. This runs on
      // every scroll frame, and a redundant class write still costs a style
      // invalidation — the same reason the reads are batched above.
      if(wantBar !== barShown){
        barShown = wantBar;
        buybar.classList.toggle('show', wantBar);
        // The WhatsApp button is fixed to the same corner; this lifts it clear.
        document.documentElement.classList.toggle('has-buybar', wantBar);
      }
    }

    if(pRects){
      for(var qi = 0; qi < parallax.length; qi++){
        var el = parallax[qi], r = pRects[qi];
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.1;
        var center = r.top + r.height/2 - vh/2;
        el.style.transform = 'translateY(' + (-center*speed).toFixed(1) + 'px)';
      }
    }

    updatePour(pourGeom);
  }
  /* The rAF gate has to be released by the frame callback, not by the end of
     onScroll. `ticking = false` used to be the last line of onScroll, which
     meant any throw inside it — or, far more common on a phone, a scroll event
     raised while requestAnimationFrame is throttled (a background tab, a
     bfcache restore, the moment Safari restores a scroll position on a
     back-navigation) — left the flag stuck at true and killed every later
     scroll for the life of the page. The visible symptom was the pour
     animation never advancing on mobile while the rest of the page was fine.
     Client feedback 27.08.2026. */
  window.addEventListener('scroll', function(){
    if(ticking) return;
    ticking = true;
    window.requestAnimationFrame(function(){ ticking = false; onScroll(); });
  }, {passive:true});
  window.addEventListener('resize', function(){
    if(pour){
      if(reduce){ pour.classList.add('pour--static'); }
      else { pour.classList.remove('pour--static'); }
    }
    // The masthead is a different height once the utility bar collapses, and
    // the pinned stage offsets itself by --mast-h. Re-measure before scrubbing.
    setMastH();
    updatePour();
  }, {passive:true});
  /* Coming back to a tab, or back to the page from checkout, can leave the gate
     closed and the scrub frozen at whatever it last painted. Reopen it and
     repaint from the real scroll position. */
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState === 'visible'){ ticking = false; setMastH(); onScroll(); }
  });
  window.addEventListener('pageshow', function(){ ticking = false; setMastH(); onScroll(); });
  onScroll();

  /* ---- mobile menu ---- */
  var burger = document.getElementById('burger');
  var menu = document.getElementById('menu');
  if(burger && menu){
    var closeMenu = function(){ menu.classList.remove('open'); burger.classList.remove('open'); burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; if(masthead) masthead.classList.remove('menu-open'); };
    burger.addEventListener('click', function(){
      var open = menu.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open?'true':'false');
      document.body.style.overflow = open?'hidden':'';
      if(masthead) masthead.classList.toggle('menu-open', open);
    });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
  }

  /* ---- accordion ---- */
  document.querySelectorAll('.acc').forEach(function(acc){
    acc.querySelectorAll('.acc__q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.parentElement;
        var isOpen = item.classList.contains('open');
        acc.querySelectorAll('.acc__item').forEach(function(i){ i.classList.remove('open'); });
        if(!isOpen) item.classList.add('open');
      });
    });
  });

  /* ---- count up ---- */
  function animateCount(el){
    var to = parseFloat(el.getAttribute('data-to'));
    var dec = el.getAttribute('data-decimal');
    if(reduce){ el.textContent = dec ? to.toFixed(1) : Math.round(to); return; }
    var start = null, dur = 1600;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var eased = 1 - Math.pow(1-p, 3);
      var val = to*eased;
      el.textContent = dec ? val.toFixed(1) : Math.round(val).toString();
      if(p<1) requestAnimationFrame(step);
      else el.textContent = dec ? to.toFixed(1) : Math.round(to).toString();
    }
    requestAnimationFrame(step);
  }
  var counts = document.querySelectorAll('.count');
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ animateCount(e.target); cio.unobserve(e.target); } });
    },{threshold:0.6});
    counts.forEach(function(c){ cio.observe(c); });
  } else { counts.forEach(animateCount); }

  /* ---- size guide (home) — bottle lineup + live recommendation ---- */
  var slider = document.getElementById('sgSlider');
  if(slider){
    /* The bottle-format range, as the client corrected it on 27.08.2026.
       Two things were wrong before: Jeroboam was listed at 3 L (a second
       "3 L" alongside Double Magnum), and Solomon / Sovereign / Primat were
       either missing or carrying each other's volume. This list is the one
       the /pages/formats table and the compatibility grid are also built
       from — if it changes, change all three. */
    var formats = [
      {l:0.75,name:'Standard'},{l:1,name:'Liter'},{l:1.5,name:'Magnum'},
      {l:3,name:'Double Magnum'},{l:4.5,name:'Rehoboam'},{l:5,name:'Jeroboam'},
      {l:6,name:'Methuselah'},{l:9,name:'Salmanazar'},{l:12,name:'Balthazar'},
      {l:15,name:'Nebuchadnezzar'},{l:18,name:'Melchior'},{l:20,name:'Solomon'},
      {l:26,name:'Sovereign'},{l:27,name:'Primat'},{l:30,name:'Melchizedek'}
    ];
    // Price is read from CATALOG at paint time so it follows the live
    // Shopify price once syncCatalog() lands.
    var MODEL_INFO = {
      L:{range:'0.75 – 6 litres', link:'/products/magnumaster-l'},
      XL:{range:'3 – 18 litres', link:'/products/magnumaster-xl'},
      XXL:{range:'4.5 – 30 litres', link:'/products/magnumaster-xxl'}
    };
    var sgFmt = document.getElementById('sgFmt');
    var sgModelName = document.getElementById('sgModelName');
    var sgModelRange = document.getElementById('sgModelRange');
    var sgModelPrice = document.getElementById('sgModelPrice');
    var sgModelLink = document.getElementById('sgModelLink');
    var sgModelAdd = document.getElementById('sgModelAdd');
    var line = document.getElementById('sgLine');

    var modelFor = function(v){ if(v<=6) return 'L'; if(v<=18) return 'XL'; return 'XXL'; };

    // build the bottle lineup (height scales with volume, sqrt for legibility)
    var bots = [];
    if(line){
      formats.forEach(function(f, i){
        /* Height scales with volume (sqrt, so 0.75 L is still legible next to
           30 L). Width scales by the SAME factor, which is the whole point:
           with a fixed width a 0.75 L bottle came out a third as tall as a
           Melchizedek but exactly as wide, so it read as short and fat.
           Scaling both keeps every bottle the same silhouette, just smaller.
           Client feedback 27.08.2026. */
        var h = 34 + 66*Math.sqrt((f.l-0.75)/29.25);
        var b = document.createElement('button');
        b.type='button'; b.className='sg-bot'; b.setAttribute('aria-label', f.name+' · '+f.l+' litres');
        b.innerHTML = '<span class="sg-bot__tag">'+f.name+' · '+f.l+' L</span>'
                    + '<span class="sg-bot__glass" style="--h:'+h.toFixed(1)+'%;--s:'+(h/100).toFixed(3)+'"></span>';
        // `i` used to be read from an enclosing scope that never defined it, so
        // tapping a bottle threw instead of moving the slider.
        b.addEventListener('click', function(){ slider.value = i; update(); });
        line.appendChild(b); bots.push(b);
      });
    }

    /* The native thumb is hidden (CSS); this puts the visible one exactly over the
       active bottle, which is what makes the control read as aligned. Ticks are
       pinned to the same centres so the axis labels agree with the bottles too. */
    var thumb = document.getElementById('sgThumb');
    var ticks = document.getElementById('sgTicks');
    var TICK_AT = [0, 6, 9, 14];   // 0.75 L, 6 L, 15 L, 30 L
    /* Reads before writes, same rule as onScroll(). This measured each bottle
       with two separate getBoundingClientRect() calls plus one for the wrapper
       — and then set thumb.style.left *between* those reads, so every tick
       forced its own synchronous layout. Now the wrapper is measured once, each
       bottle once, and nothing is positioned until all of it is known. */
    var centerOf = function(i, wrapLeft){
      if(!bots[i]) return null;
      var r = bots[i].getBoundingClientRect();
      return r.left + r.width/2 - wrapLeft;
    };
    var layout = function(idx){
      var wrap = slider.parentNode;
      if(!wrap) return;
      // ---- read
      var wrapLeft = wrap.getBoundingClientRect().left;
      var thumbC = centerOf(idx, wrapLeft);
      var tickEls = ticks ? ticks.querySelectorAll('span') : [];
      var tickC = [];
      for(var n = 0; n < tickEls.length; n++) tickC.push(centerOf(TICK_AT[n], wrapLeft));
      // ---- write
      if(thumb && thumbC !== null) thumb.style.left = thumbC + 'px';
      for(var m = 0; m < tickEls.length; m++){
        if(tickC[m] !== null) tickEls[m].style.left = tickC[m] + 'px';
      }
    };

    var update = function(){
      var idx = Math.max(0, Math.min(formats.length-1, parseInt(slider.value,10)||0));
      var f = formats[idx];
      var v = f.l;
      var m = modelFor(v);
      var info = MODEL_INFO[m];
      var isDe = document.body.classList.contains('is-de');
      if(sgFmt) sgFmt.textContent = f.name + ' · ' + f.l + ' L';
      if(sgModelName) sgModelName.textContent = m;
      if(sgModelRange) sgModelRange.textContent = (isDe ? 'Passt ' : 'Fits ') + info.range;
      if(sgModelPrice) sgModelPrice.innerHTML = euro(CATALOG[m].price) + ' <small>' + (isDe ? 'exkl. MwSt. &amp; Versand' : 'excl. VAT &amp; shipping') + '</small>';
      if(sgModelLink){ sgModelLink.href = info.link; sgModelLink.textContent = isDe ? ('MagnuMaster ' + m + ' ansehen') : ('View MagnuMaster ' + m); }
      if(sgModelAdd) sgModelAdd.setAttribute('data-add', m);
      bots.forEach(function(b,i){ b.classList.toggle('on', i===idx); });
      slider.setAttribute('aria-valuetext', f.name + ' · ' + f.l + ' litres');
      layout(idx);
    };
    slider.addEventListener('input', update);
    window.addEventListener('resize', update);
    update();
    // Bottle widths settle after webfonts land; re-pin the thumb once they do.
    window.addEventListener('load', update);
    repaintHooks.push(update);
  }

  /* ---- product gallery (PDP) ---- */
  var pdpMain = document.getElementById('pdpMain');
  if(pdpMain){
    document.querySelectorAll('.pdp__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        var src = t.getAttribute('data-full') || (t.querySelector('img') && t.querySelector('img').src);
        if(!src) return;
        // Diagrams (bottle-size charts) are shown whole; photos still fill the frame.
        var contain = t.getAttribute('data-fit') === 'contain';
        pdpMain.style.opacity = '0';
        setTimeout(function(){
          pdpMain.src = src;
          pdpMain.classList.toggle('is-contain', contain);
          pdpMain.style.opacity = '1';
        }, 220);
        document.querySelectorAll('.pdp__thumb').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ---- magnetic buttons ----
     The custom circle cursor that used to live here was removed: it hid the
     native pointer, which made small targets (cookie banner) hard to hit. The
     .cursor / .cursor-dot markup is left in place but permanently hidden by CSS. */
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(fine && !reduce){
    // magnetic buttons
    document.querySelectorAll('.btn').forEach(function(btn){
      btn.addEventListener('mousemove', function(e){
        var r = btn.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width/2;
        var my = e.clientY - r.top - r.height/2;
        btn.style.transform = 'translate('+(mx*0.22)+'px,'+(my*0.32)+'px)';
      });
      btn.addEventListener('mouseleave', function(){ btn.style.transform=''; });
    });
  }

  /* ---- duplicate marquee + partner logos for seamless loop ---- */
  var mq = document.getElementById('marquee');
  if(mq){ mq.innerHTML += mq.innerHTML; }
  var trustLogos = document.getElementById('trustLogos');
  if(trustLogos && !reduce){ trustLogos.innerHTML += trustLogos.innerHTML; }

  /* ---- click-to-play video (real pour footage) ---- */
  document.querySelectorAll('.video__play').forEach(function(btn){
    btn.addEventListener('click', function(){
      var v = btn.parentElement.querySelector('video');
      if(!v) return;
      btn.classList.add('hidden');
      var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
    });
  });

  /* ---- smooth anchor (same-page only) + close menu ----
     A [data-defer-render] section above the target is only an estimated
     height until it renders, so a scroll to it lands wherever the estimates
     add up to and the page then moves as they draw. Render the ones above
     the target first; only a visitor who jumps down pays for that. The menu
     links are "/#reviews", not "#reviews", so same-page links of that shape
     are taken here too, and a hash on arrival is corrected once. */
  function anchorTarget(id){
    if(!id || id.length<2) return null;
    try { return document.querySelector(id); } catch(_){ return null; }
  }
  function renderAbove(t){
    document.querySelectorAll('[data-defer-render]').forEach(function(s){
      if(s.contains(t) || (s.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING)) s.style.contentVisibility = 'visible';
    });
  }
  function goTo(t, smooth){
    renderAbove(t);
    t.scrollIntoView({behavior: smooth && !reduce ? 'smooth' : 'auto', block:'start'});
  }
  var arrival = anchorTarget(location.hash);
  if(arrival){ goTo(arrival, false); }
  document.querySelectorAll('a[href*="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var href = a.getAttribute('href');
      if(href.charAt(0)!=='#' && (a.origin!==location.origin || a.pathname!==location.pathname)) return;
      var t = anchorTarget(a.hash);
      if(t){
        e.preventDefault(); goTo(t, true);
        if(href.charAt(0)!=='#' && history.replaceState) history.replaceState(null, '', a.hash);
      }
    });
  });

  /* ---- whole-box click targets ----
     The product cards already redirect wherever you click them (.card__stretch).
     The same now applies to every other box that leads somewhere: the use-case
     cards, the journal / guides posts and the feature tiles. The overlay is
     aria-hidden and untabbable — the real link inside stays the accessible one,
     and is raised above the overlay by CSS so it keeps working normally. */
  document.querySelectorAll('.uc, .post, .feature').forEach(function(box){
    if(box.querySelector(':scope > .card__stretch')) return;
    // Prefer the box's explicit call to action, else its first link.
    var cta = box.querySelector('.uc__link, .post__body a[href], a[href]');
    if(!cta) return;
    var href = cta.getAttribute('href');
    if(!href || href.charAt(0) === '#') return;
    var a = document.createElement('a');
    a.className = 'card__stretch';
    a.setAttribute('href', href);
    a.setAttribute('tabindex', '-1');
    a.setAttribute('aria-hidden', 'true');
    if(getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.insertBefore(a, box.firstChild);
  });

  /* ---- footer guides strip (injected so every page links the new pages) ---- */
  var ftop = document.querySelector('.footer__top');
  if(ftop && !document.querySelector('.footer__guides')){
    var fg = document.createElement('div');
    fg.className = 'footer__guides';
    // The English text stays inline so this renders correctly with no
    // dictionary at all; applyLang() swaps it via the data-i18n keys.
    function fgLink(href, key, en){
      return '<a href="' + href + '"><span data-i18n="' + key + '">' + en + '</span></a>';
    }
    fg.innerHTML = '<span class="gh"><span data-i18n="foot.guidesHead">Guides &amp; use cases</span></span>'+
      fgLink('/pages/compare', 'foot.compare', 'Compare L · XL · XXL')+
      fgLink('/pages/hospitality', 'foot.hospitality', 'For restaurants &amp; hotels')+
      fgLink('/pages/gift', 'foot.gift', 'Collector &amp; gifting')+
      fgLink('/pages/engraving', 'foot.engraving', 'Engraving &amp; custom coating')+
      fgLink('/pages/ral-colours', 'foot.ral', 'RAL colour gallery')+
      fgLink('/pages/serve-large-format-wine', 'foot.serve', 'How to serve large-format wine')+
      // "Guides & Stories" (the hub) and "Press & partners" now live in the
      // Company column, so they are no longer repeated here.
      fgLink('/pages/formats', 'foot.formats', 'MagnuMaster by bottle format');
    ftop.parentNode.insertBefore(fg, ftop.nextSibling);
  }

  /* ---- footer "since 2011" badge (injected so every page stays in sync) ---- */
  var fbrand = document.querySelector('.footer__brand');
  if(fbrand && !fbrand.querySelector('.footer__since')){
    var badge = document.createElement('div');
    badge.className = 'footer__since';
    badge.innerHTML = '<span data-i18n="foot.since">Handcrafted in Austria · Since 2011</span>';
    var fp = fbrand.querySelector('p');
    if(fp){ fp.parentNode.insertBefore(badge, fp.nextSibling); } else { fbrand.appendChild(badge); }
  }

  /* ============================================================
     STORE — Shopify's cart, over the AJAX Cart API.
     ------------------------------------------------------------
     The cart used to be a localStorage object this file owned, priced
     from a catalogue the site carried, and turned into a Shopify cart
     only at the moment of checkout. That is where a whole class of
     bugs lived: a cart that disagreed with its checkout, a quantity
     that had to be reconciled on the buyer's return, a price that was
     right on the page and wrong on the invoice.

     Now the cart on screen IS the cart Shopify will charge. It is
     seeded from window.MM_CART (rendered by Liquid, so the first paint
     needs no request) and every change goes through /cart/change.js.
     ============================================================ */
  var CART = window.MM_CART || {items:[], item_count:0, total_price:0};

  function cartCount(){ return CART.item_count || 0; }
  function cartTotal(){ return (CART.total_price || 0) / 100; }   // major units, as before

  function setCart(c){
    if(c && typeof c === 'object' && c.items) CART = c;
    updateStoreUI();
    return CART;
  }

  /* One place where a cart call can fail, so one place that explains it.
     Shopify answers a rejected line with a JSON body carrying a
     "description", which is a sentence written for the buyer. */
  function cartCall(path, body){
    return fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if(!r.ok) throw new Error(j.description || j.message || ('Cart error ' + r.status));
        return j;
      });
    });
  }

  function refreshCart(){
    return fetch(ROUTES.cart + '.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(setCart);
  }

  /* What one line costs per unit, in major units — used by the price
     preview in the configurator, which has to be right before anything
     has been added to a cart. */
  function lineUnit(it){
    var c = CATALOG[it.code];
    if(!c) return 0;
    return (it.coating && c.variants && c.variants.custom ? c.variants.custom.price : c.price);
  }

  function variantId(code, coating){
    var c = CATALOG[code];
    if(!c || !c.variants) return null;
    var v = coating ? c.variants.custom : c.variants.standard;
    return v ? v.id : null;
  }

  /* The quick "Add to cart" buttons: the standard finish, quantity one,
     no personalisation. Anything configured goes through the product
     form instead (addFromForm below), because that is what carries the
     engraving text and the artwork. */
  function addToCart(code, qty, opts){
    var id = (opts && opts.id) || variantId(code, false);
    if(!id) return Promise.reject(new Error('No variant for ' + code));
    return cartCall(ROUTES.cartAdd + '.js', {items:[{id:id, quantity:qty || 1}]})
      .then(refreshCart);
  }

  /* The configured add. Posting the form itself rather than a JSON body
     is what lets the logo file ride along: Shopify stores it against the
     order as a line-item property, which is exactly what the serverless
     upload endpoint used to be for. */
  function addFromForm(form){
    var fd = new FormData(form);

    // The finish radios are a UI control, not a cart field — they only
    // decide which variant id goes in. Shopify ignores unknown params,
    // but there is no reason to send one.
    fd.delete('cfgFinish');

    // An untouched file input still contributes an empty File, and an
    // empty property would show as a blank line in the cart and on the
    // packing slip. Drop anything that carries nothing.
    var drop = [];
    fd.forEach(function(v, k){
      if(k.indexOf('properties[') !== 0) return;
      var empty = (typeof v === 'string') ? v.trim() === '' : (!v || !v.size);
      if(empty) drop.push(k);
    });
    drop.forEach(function(k){ fd.delete(k); });

    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Accept':'application/json'},   // no Content-Type: the browser sets the multipart boundary
      body: fd
    }).then(function(r){
      return r.json().catch(function(){ return {}; }).then(function(j){
        if(!r.ok) throw new Error(j.description || j.message || ('Cart error ' + r.status));
        return j;
      });
    }).then(refreshCart);
  }

  // Report an add to the funnel at the price actually charged, so the coating
  // surcharge is not missing from AddToCart value while it is present at checkout.
  function trackAdd(it){
    if(!CATALOG[it.code]) return;
    track('addToCart', {code:it.code, name:CATALOG[it.code].name, price:lineUnit(it), qty:it.qty||1});
  }

  /* Quantities are keyed by Shopify's line key, not by an index: a line
     removed while the page was open would otherwise shift every index
     after it and change the wrong row. */
  function setQtyByKey(key, qty){
    return cartCall(ROUTES.cartChange + '.js', {id:key, quantity:Math.max(0, qty)})
      .then(setCart)
      .catch(function(err){ toast(esc(err.message)); return CART; });
  }
  function changeQtyByKey(key, d){
    var line = (CART.items || []).filter(function(i){ return i.key === key; })[0];
    if(!line) return;
    setQtyByKey(key, line.quantity + d);
  }
  function removeByKey(key){ setQtyByKey(key, 0); }

  /* ---- bank-transfer offer -------------------------------------------------
     Card and wallet fees on a €3.000+ order are significant, so bank transfer
     is worth actively steering buyers towards.

     It paints only when the theme setting is on — that switch is the
     promise that a matching discount really exists in Shopify. The theme
     cannot apply a discount; Shopify owns the money. Advertising the
     saving before the discount exists would quote one price at the cart
     and charge another at checkout. */
  function paintBankNote(){
    var note = document.getElementById('bankTransferNote');
    if(!note) return;

    var cfg = SHOP.bankTransfer || {};
    var pct = Number(cfg.discountPercent) || 0;
    if(!cfg.enabled || pct <= 0){ note.hidden = true; return; }

    var saving = cartTotal() * pct / 100;
    note.hidden = false;
    note.innerHTML =
      // No data-i18n on the badge: paint() would write the dictionary value
      // straight back in, placeholder and all. paint() calls this function
      // instead, which is what keeps the whole note translated.
      '<span class="paynote__badge">' +
        MM_I18N.t('pay.bank.badge').replace('{pct}', pct) + '</span>' +
      '<p class="paynote__lead"><b>' +
        MM_I18N.t('pay.bank.headline').replace('{pct}', pct) + '</b></p>' +
      '<p class="paynote__body">' + MM_I18N.t('pay.bank.body') + '</p>' +
      /* Shopify cannot discount by payment method, and the client would rather
         not ask a buyer to remember a code: the order is placed at full price
         and the percentage comes off the invoice that is raised afterwards, by
         hand, in the Shopify admin. So the notice promises an amended invoice,
         not a code. Client instruction 27.08.2026. The same sentence has to be
         on Shopify's own checkout — it goes in the Bank transfer manual payment
         method's "Additional details", see MIGRATION.md §10. */
      '<p class="paynote__body">' +
        MM_I18N.t('pay.bank.code').replace('{pct}', pct) + '</p>' +
      (saving > 0
        ? '<p class="paynote__save">' +
            MM_I18N.t('pay.bank.save').replace('{amount}', euro(saving)) + '</p>'
        : '');
  }

  /* ---- where we can actually deliver ---------------------------------------
     Shopify only carries a rate for the destinations on the carrier's card
     (the Shipping theme setting). Everywhere else has no rate on purpose, and Shopify
     answers that with "no shipping methods available" three screens into its
     own checkout — after the buyer has typed a full address. So we ask for the
     country here, while the cart is still ours, and send anyone we cannot
     deliver to into the quote flow instead.

     A guess is never good enough to block a sale on: the geo lookup only
     preselects the dropdown, and the buyer can change it. */
  var SHIP_KEY = 'mm_ship_country';
  var SHIP_OTHER = '-';                       // the explicit "not listed" choice
  var SHIPS_TO = SHOP.shipsTo || [];

  // English fallback names, for a browser without Intl.DisplayNames. With it,
  // the dropdown is in the visitor's own language and this is never used.
  var CC_EN = {
    AT:'Austria', BE:'Belgium', BG:'Bulgaria', CY:'Cyprus', CZ:'Czechia',
    DE:'Germany', DK:'Denmark', EE:'Estonia', ES:'Spain', FI:'Finland',
    FR:'France', GR:'Greece', HR:'Croatia', HU:'Hungary', IE:'Ireland',
    IT:'Italy', LT:'Lithuania', LU:'Luxembourg', LV:'Latvia', MT:'Malta',
    NL:'Netherlands', PL:'Poland', PT:'Portugal', RO:'Romania', SE:'Sweden',
    SI:'Slovenia', SK:'Slovakia', AL:'Albania', BA:'Bosnia and Herzegovina',
    CH:'Switzerland', FO:'Faroe Islands', GB:'United Kingdom', IS:'Iceland',
    MC:'Monaco', ME:'Montenegro', MK:'North Macedonia', NO:'Norway',
    RS:'Serbia', TR:'Türkiye', AE:'United Arab Emirates', AU:'Australia',
    BR:'Brazil', CL:'Chile', CN:'China', KZ:'Kazakhstan', MX:'Mexico',
    MY:'Malaysia', SG:'Singapore', US:'United States', ZA:'South Africa'
  };

  function countryName(cc){
    try{
      var dn = new Intl.DisplayNames([getLang()], {type:'region'});
      var n = dn.of(cc);
      if(n && n !== cc) return n;
    }catch(e){}
    return CC_EN[cc] || cc;
  }

  function shipsTo(cc){ return !!cc && cc !== SHIP_OTHER && SHIPS_TO.indexOf(cc) >= 0; }

  // '' = not answered yet, an ISO code, or SHIP_OTHER.
  function shipCountry(){
    try{ return localStorage.getItem(SHIP_KEY) || ''; }catch(e){ return ''; }
  }
  function setShipCountry(cc){
    try{ cc ? localStorage.setItem(SHIP_KEY, cc) : localStorage.removeItem(SHIP_KEY); }catch(e){}
  }

  // True only once the buyer (or the geo guess) has named a country we cannot
  // reach. An unanswered dropdown never blocks anything.
  function shipBlocked(){
    var cc = shipCountry();
    return !!cc && !shipsTo(cc);
  }

  function paintShipGate(){
    var sel = document.getElementById('shipToCountry');
    var warn = document.getElementById('shipToWarn');
    var wrap = document.getElementById('shipTo');
    if(!sel || !warn) return;

    var cur = shipCountry();
    // The stored value can be a country we do not serve — the geo lookup names
    // the real place so the warning can too ("we cannot ship to Japan"), but
    // the dropdown only lists the ones we do serve, so it lands on "not
    // listed". Selection and message deliberately answer different questions.
    var curSel = shipsTo(cur) ? cur : (cur ? SHIP_OTHER : '');

    // Names are language-dependent, so the list is rebuilt on every repaint.
    var opts = SHIPS_TO.map(function(cc){ return {cc:cc, name:countryName(cc)}; });
    opts.sort(function(a,b){ return a.name.localeCompare(b.name, getLang()); });

    sel.innerHTML =
      '<option value=""' + (curSel ? '' : ' selected') + '>' + esc(MM_I18N.t('ship.pick')) + '</option>' +
      opts.map(function(o){
        return '<option value="' + o.cc + '"' + (o.cc === curSel ? ' selected' : '') + '>' + esc(o.name) + '</option>';
      }).join('') +
      '<option value="' + SHIP_OTHER + '"' + (curSel === SHIP_OTHER ? ' selected' : '') + '>' +
        esc(MM_I18N.t('ship.other')) + '</option>';

    if(wrap) wrap.hidden = false;

    var blocked = shipBlocked();
    warn.hidden = !blocked;
    if(blocked){
      var where = cur === SHIP_OTHER ? MM_I18N.t('ship.other').toLowerCase() : countryName(cur);
      var qs = cur !== SHIP_OTHER ? '?country=' + encodeURIComponent(countryName(cur)) : '';
      warn.innerHTML =
        '<p class="shipwarn__lead">' + MM_I18N.t('ship.warn.lead').replace('{country}', esc(where)) + '</p>' +
        '<p class="shipwarn__body">' + MM_I18N.t('ship.warn.body') + '</p>' +
        '<a class="btn btn--primary" href="' + ROUTES.quote + qs + '">' +
          esc(MM_I18N.t('ship.warn.cta')) + '</a>';
    }

    // The checkout button goes away rather than greying out: a disabled button
    // invites a second click, and the quote CTA above is the real next step.
    document.querySelectorAll('#cartCheckoutBtn, [data-checkout]').forEach(function(b){
      b.style.display = blocked ? 'none' : '';
    });
  }

  /* Preselect from the visitor's location, once, and only as a suggestion —
     on every page, not just the cart, so an add-to-cart from a product page can
     say something straight away rather than letting them reach the cart first.
     The lookup itself is the one the language switch already makes and is
     cached for the tab session, so this costs no extra request. */
  function guessShipCountry(){
    if(shipCountry()) return;                       // already answered
    country().then(function(cc){
      if(!cc || shipCountry()) return;
      setShipCountry(shipsTo(cc) ? cc : SHIP_OTHER);
      paintShipGate();
    });
  }

  document.addEventListener('change', function(e){
    var sel = e.target;
    if(!sel || sel.id !== 'shipToCountry') return;
    setShipCountry(sel.value);
    paintShipGate();
  });

  /* ---- business buyers: company + VAT / tax number -------------------------
     Shopify's own checkout only asks for a VAT number inside the EU, but the
     export paperwork for a B2B order needs one wherever it is going. Collected
     here, it rides to the order as a cart attribute and shows up in the admin
     next to the order — which is what the invoice and the customs documents
     are written from. It never changes what is charged: VAT is Shopify's
     decision, made at checkout against the address and the VIES check. */
  var BIZ_KEY = 'mm_business';
  function bizDetails(){
    var c = document.getElementById('bizCompany');
    var v = document.getElementById('bizVat');
    if(c || v){
      return { company: (c && c.value.trim()) || '', vat: (v && v.value.trim()) || '' };
    }
    try{ return JSON.parse(localStorage.getItem(BIZ_KEY)) || {company:'', vat:''}; }
    catch(e){ return {company:'', vat:''}; }
  }
  (function wireBiz(){
    var box = document.getElementById('bizBox');
    if(!box) return;
    var c = document.getElementById('bizCompany');
    var v = document.getElementById('bizVat');
    var saved = {company:'', vat:''};
    try{ saved = JSON.parse(localStorage.getItem(BIZ_KEY)) || saved; }catch(e){}
    if(c) c.value = saved.company || '';
    if(v) v.value = saved.vat || '';
    // Open on arrival if they filled it in last time, so it is not "lost".
    if(saved.company || saved.vat) box.setAttribute('open', '');
    box.addEventListener('input', function(){
      var d = {company: c ? c.value.trim() : '', vat: v ? v.value.trim() : ''};
      try{ localStorage.setItem(BIZ_KEY, JSON.stringify(d)); }catch(e){}
    });
  })();

  function updateStoreUI(){
    var n=cartCount(), t=cartTotal();
    paintBankNote();
    paintShipGate();
    // The price is wrapped so phones can drop it: the nav row also carries the
    // language switcher now, and "€12,800 · Cart (2)" pushed into the logo.
    // The count is what matters at a glance; the total is on the cart page.
    var label = '<span class="nav__cart-amt">' + euro(t) + ' · </span>' +
                '<span data-i18n="nav.cart">' + MM_I18N.t('nav.cart') + '</span>' + (n ? ' ('+n+')' : '');
    document.querySelectorAll('.nav__cart').forEach(function(el){ el.innerHTML = label; });
    var ml = document.querySelector('[data-cartlink] .n'); if(ml) ml.textContent = n ? n : '0';
    renderCart();
  }

  // the nav cart is always a real link in the theme; this only covers a
  // section that renders it as a span.
  document.querySelectorAll('.nav__cart').forEach(function(el){
    if(el.tagName !== 'A'){
      el.setAttribute('role','link'); el.setAttribute('tabindex','0');
      el.addEventListener('click', function(){ window.location.href=ROUTES.cart; });
      el.addEventListener('keydown', function(e){ if(e.key==='Enter'){ window.location.href=ROUTES.cart; } });
    }
  });

  // inject a Cart entry into the mobile menu (hidden nav cart on small screens)
  (function(){
    var m = document.getElementById('menu'); if(!m) return;
    var foot = m.querySelector('.menu__foot');
    if(foot && !m.querySelector('[data-cartlink]')){
      var a = document.createElement('a'); a.href=ROUTES.cart; a.setAttribute('data-cartlink','');
      a.innerHTML = '<span data-i18n="nav.cart">Cart</span> <span class="n">0</span>';
      m.insertBefore(a, foot);
    }
  })();

  // lightweight toast
  var toastEl=null, toastT=null;
  function toast(html){
    if(!toastEl){ toastEl=document.createElement('div'); toastEl.className='toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html;
    requestAnimationFrame(function(){ toastEl.classList.add('show'); });
    clearTimeout(toastT); toastT=setTimeout(function(){ if(toastEl) toastEl.classList.remove('show'); }, 3400);
  }

  // add-to-cart triggers anywhere: [data-add="L|XL|XXL"]
  document.querySelectorAll('[data-add]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var code = btn.getAttribute('data-add'); if(!CATALOG[code]) return;
      e.preventDefault();
      btn.setAttribute('disabled','');
      // The variant is on the button where Liquid rendered the card; the
      // code is only how we look the product up for the toast and the
      // funnel event.
      addToCart(code, 1, {id: btn.getAttribute('data-variant-id') || null}).then(function(){
        trackAdd({code:code, qty:1});
        // Nothing is refused here — the cradle goes in the cart either way.
        // But if we already know we cannot deliver there, saying so now is
        // kinder than letting them configure an order they cannot place.
        if(shipBlocked()){
          var cc = shipCountry();
          toast(MM_I18N.t('ship.warn.toast').replace('{country}',
            cc === SHIP_OTHER ? MM_I18N.t('ship.other').toLowerCase() : esc(countryName(cc))));
          return;
        }
        toast(MM_I18N.t('js.addedToast').replace('{name}', CATALOG[code].name).replace('{url}', ROUTES.cart));
      }).catch(function(err){
        toast(esc(err.message));
      }).then(function(){ btn.removeAttribute('disabled'); });
    });
  });

  function esc(s){ return (s||'').replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  /* The configuration, read back off the line item Shopify is holding.
     The properties are the ones the product form posted, so what is
     printed here is literally what the workshop will be told to make. */
  function optSummary(it){
    var bits = [];
    if(it.variant_title && !/default/i.test(it.variant_title)) bits.push(esc(it.variant_title));
    (it.properties ? Object.keys(it.properties) : []).forEach(function(k){
      if(k.charAt(0) === '_') return;                 // Shopify's convention for hidden properties
      var v = it.properties[k];
      if(v === null || v === undefined || v === '') return;
      // A file property comes back as a URL; show the name, link the file.
      if(typeof v === 'string' && /^https?:\/\//.test(v)){
        var nm = decodeURIComponent(v.split('/').pop().split('?')[0]);
        bits.push(esc(k) + ': <a href="' + esc(v) + '" target="_blank" rel="noopener">' + esc(nm) + '</a>');
      } else {
        bits.push(esc(k) + ': ' + esc(String(v)));
      }
    });
    return bits;
  }

  // cart page rendering
  function renderCart(){
    var wrap = document.getElementById('cartItems'); if(!wrap) return;
    var empty = document.getElementById('cartEmpty');
    var summaryBox = document.getElementById('cartSummary');
    var items = (CART.items || []).filter(function(i){ return i.quantity > 0; });
    var has = items.length > 0;
    document.querySelectorAll('.needs-cart').forEach(function(el){ el.style.display = has ? '' : 'none'; });
    wrap.innerHTML='';
    if(!has){
      if(empty) empty.style.display='block';
      wrap.style.display='none';
      if(summaryBox) summaryBox.style.display='none';
      return;
    }
    if(empty) empty.style.display='none';
    wrap.style.display='block';
    if(summaryBox) summaryBox.style.display='block';
    items.forEach(function(it){
      var opts = optSummary(it).map(function(b){ return '<div class="ca" style="text-transform:none;letter-spacing:0;color:var(--ink-soft)">'+b+'</div>'; }).join('');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      var k = it.key;
      var row=document.createElement('div'); row.className='cart__row';
      row.innerHTML =
        (img ? '<img src="'+esc(img)+'" alt="'+esc(it.product_title)+'" loading="lazy">' : '<div></div>')+
        '<div><div class="nm">'+esc(it.product_title)+'</div>'+opts+
          '<div class="unit">'+money(it.original_price)+' '+MM_I18N.t('js.exclVatEach')+'</div></div>'+
        '<div class="rt"><div class="qty">'+
          '<button type="button" data-dec="'+esc(k)+'" aria-label="Decrease quantity">&minus;</button>'+
          '<span class="v">'+it.quantity+'</span>'+
          '<button type="button" data-inc="'+esc(k)+'" aria-label="Increase quantity">+</button>'+
        '</div><div class="line">'+money(it.original_line_price)+'</div>'+
        '<button type="button" class="cart__remove" data-remove="'+esc(k)+'">'+MM_I18N.t('js.remove')+'</button></div>';
      wrap.appendChild(row);
    });
    var subEl=document.getElementById('cartSubtotal'); if(subEl) subEl.textContent=money(CART.total_price);
    var totEl=document.getElementById('cartTotalVal'); if(totEl) totEl.textContent=money(CART.total_price);
    wrap.querySelectorAll('[data-inc]').forEach(function(b){ b.onclick=function(){ changeQtyByKey(b.getAttribute('data-inc'), 1); }; });
    wrap.querySelectorAll('[data-dec]').forEach(function(b){ b.onclick=function(){ changeQtyByKey(b.getAttribute('data-dec'), -1); }; });
    wrap.querySelectorAll('[data-remove]').forEach(function(b){ b.onclick=function(){ removeByKey(b.getAttribute('data-remove')); }; });
  }

  /* ============================================================
     CHECKOUT — hand off to Shopify's hosted checkout.
     Shopify retired the Checkout API in April 2025; cartCreate ->
     cart.checkoutUrl is the only supported path. We build the cart
     at checkout time (not on every +/- click) so the UI stays instant.
     ============================================================ */
  function cartLines(){
    return (CART.items || []).map(function(i){
      return {
        code: (i.product_title || '').replace(/^MagnuMaster\s*/i, '').toUpperCase(),
        name: i.product_title,
        price: (i.original_price || 0) / 100,
        qty: i.quantity
      };
    });
  }

  /* Hand off to Shopify's hosted checkout.

     This used to be the most delicate function on the site: it built a
     Shopify cart with cartCreate, stored the returned id so a later
     visit could ask whether the order had completed, and redirected to
     a checkoutUrl. All of that existed because the cart was ours and
     the checkout was Shopify's.

     They are the same cart now, so this is a redirect. */
  function startCheckout(btn){
    var lines = cartLines();
    if(!lines.length){ toast(MM_I18N.t('js.cartEmpty')); return; }
    // Shopify has no rate for this destination, so its checkout would refuse
    // after the address step. Say so here instead of sending them into it.
    if(shipBlocked()){
      var cc = shipCountry();
      toast(MM_I18N.t('ship.warn.toast').replace('{country}',
        cc === SHIP_OTHER ? MM_I18N.t('ship.other').toLowerCase() : esc(countryName(cc))));
      paintShipGate();
      return;
    }
    // keep the original markup so the label restores (and re-translates) on error
    var prev = btn ? btn.innerHTML : '';
    if(btn){
      btn.innerHTML = '<span data-i18n="js.openingCheckout">' + MM_I18N.t('js.openingCheckout') + '</span>';
      btn.setAttribute('aria-busy','true'); btn.setAttribute('disabled','');
    }
    // Fire before the redirect — once we hand off to Shopify's checkout, no
    // script of ours runs again.
    track('beginCheckout', lines);

    /* Cart attributes: the company name, the VAT number and the campaign
       that brought the visit. They land on the order in the admin, and
       from there on the invoice and the export papers. None of them
       change what is charged — VAT is Shopify's decision, made at
       checkout from the address and its own VIES check.

       Writing them must never be able to block a sale, so a failure here
       is swallowed and the buyer goes to checkout regardless. */
    var biz = bizDetails();
    var attrs = {
      'Language': getLang(),
      'Company': biz.company || '',
      'VAT number': biz.vat || '',
      'Delivery country': shipsTo(shipCountry()) ? countryName(shipCountry()) : ''
    };
    var attr = attribution();
    Object.keys(attr).forEach(function(k){ attrs[k] = String(attr[k]).slice(0, 500); });

    var go = function(){ window.location.href = ROUTES.checkout; };
    cartCall(ROUTES.cartUpdate + '.js', {attributes: attrs}).then(go, go);
  }

  document.querySelectorAll('#cartCheckoutBtn, [data-checkout]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); startCheckout(btn); });
  });

  /* There is nothing to reconcile any more.

     The static site remembered which Shopify cart it had sent the buyer
     to, and on their return asked whether that cart still existed —
     gone meant paid, still open meant abandoned — so it could clear a
     localStorage cart that Shopify's own thank-you page had no way to
     touch. With one cart, Shopify empties it when the order completes
     and the next page load simply shows it empty. */

  /* ---- keep every printed price in step with the catalogue -------- */
  function repaintPrices(){
    updateStoreUI();
    configRoots.forEach(paintConfig);
    repaintHooks.forEach(function(fn){ fn(); });
    // Any price in the markup, tagged <span class="card__price" data-price="XL">€3,300<small>…
    // Only the leading text node is rewritten, so trailing "excl. VAT" markup survives.
    document.querySelectorAll('[data-price]').forEach(function(el){
      var p = CATALOG[el.getAttribute('data-price')];
      if(!p) return;
      var first = el.firstChild;
      if(first && first.nodeType === 3) first.nodeValue = euro(p.price);
      else el.textContent = euro(p.price);
    });
  }
  /* The Liquid templates print live prices themselves. The editorial
     pages — compare, formats, the home collection strip — carry the
     figures in their markup, and those are what this corrects. It runs
     once, from data already in the page: no request, no flash of a
     stale number. */
  repaintPrices();

  /* ---- product configurator (PDP): finish/RAL, engraving, logo upload, qty ---- */
  function readConfig(root){
    var finish = (root.querySelector('input[name="cfgFinish"]:checked')||{}).value || 'standard';
    var coating = finish === 'custom';
    var ralEl = root.querySelector('[data-cfg="ral"]');
    var engEl = root.querySelector('[data-cfg="engraving"]');
    var qtyEl = root.querySelector('[data-cfg="qtyval"]');
    var logo = root.getAttribute('data-logo') || '';
    return {
      code: root.getAttribute('data-config'),
      coating: coating,
      ral: coating && ralEl ? ralEl.value.trim() : '',
      engraving: engEl ? engEl.value.trim() : '',
      logo: logo,
      logoUrl: root.getAttribute('data-logo-url') || '',
      qty: qtyEl ? Math.max(1, parseInt(qtyEl.textContent,10)||1) : 1
    };
  }
  function paintConfig(root){
    var cfg = readConfig(root);
    var base = CATALOG[cfg.code] ? CATALOG[cfg.code].price : 0;
    var unit = lineUnit(cfg);
    var total = unit * cfg.qty;

    /* Keep the form pointing at the variant the buyer has actually
       chosen, and keep the RAL field out of the submission while the
       standard finish is selected — a disabled input is not posted, so
       an abandoned colour cannot ride along on a line that has no
       custom coating. */
    var vid = root.querySelector('[data-cfg="variantid"]');
    var id = variantId(cfg.code, cfg.coating);
    if(vid && id) vid.value = id;
    var ralIn = root.querySelector('[data-cfg="ral"]');
    if(ralIn) ralIn.disabled = !cfg.coating;
    var qtyIn = root.querySelector('[data-cfg="qtyinput"]');
    if(qtyIn) qtyIn.value = cfg.qty;
    // Keep both language spans — this element is repainted on every change, so
    // writing plain English here would permanently break the DE toggle.
    var amt = root.querySelector('[data-cfg="amt"]');
    if(amt) amt.innerHTML = euro(total) +
      ' <small><span data-i18n="js.exclVat">' + MM_I18N.t('js.exclVat') + '</span></small>';
    var bd = root.querySelector('[data-cfg="breakdown"]');
    if(bd){
      var rows = '<div><span>'+CATALOG[cfg.code].name+' × '+cfg.qty+'</span><span>'+euro(base*cfg.qty)+'</span></div>';
      rows += '<div><span>'+MM_I18N.t('js.engraving')+'</span><span style="color:#2f7d4f">'+MM_I18N.t('js.included')+'</span></div>';
      if(cfg.coating) rows += '<div><span>'+MM_I18N.t('js.coating')+(cfg.ral?(' · '+esc(cfg.ral)):'')+' × '+cfg.qty+'</span><span>'+euro(coatingOf(cfg.code)*cfg.qty)+'</span></div>';
      bd.innerHTML = rows;
    }
    var sub = root.querySelector('[data-cfg="ralsub"]'); if(sub) sub.hidden = !cfg.coating;
    var sw = root.querySelector('[data-cfg="swatch"]');
    if(sw && cfg.ral){ var hex = ralToHex(cfg.ral); if(hex) sw.style.background = hex; }
    paintRalGrid(root, cfg.ral);
  }
  // tiny RAL→hex lookup for the live swatch (indicative only; final colour confirmed personally)
  var RAL_HEX = {'3005':'#5e2129','3004':'#6b1f2a','5004':'#1f262b','9005':'#0e0e10','9011':'#1c1f22','1036':'#7a5320','9006':'#a5a8a6','6005':'#114232','5011':'#1a2b3c','8017':'#45322e','3003':'#8a1f2b','9010':'#f1ece1','7016':'#383e42','5002':'#20214c'};
  function ralToHex(v){ var m=(v||'').match(/(\d{4})/); return m ? (RAL_HEX[m[1]]||null) : null; }

  /* Clickable RAL palette. Order matters: Anthracite Grey leads because it is
     the standard finish. Must stay in sync with the <datalist> on the PDPs. */
  var RAL_LIST = [
    {code:'7016', name:'Anthracite Grey'},  {code:'9011', name:'Graphite Black'},
    {code:'9005', name:'Jet Black'},        {code:'3005', name:'Wine Red'},
    {code:'3004', name:'Purple Red'},       {code:'3003', name:'Ruby Red'},
    {code:'5004', name:'Black Blue'},       {code:'5011', name:'Steel Blue'},
    {code:'6005', name:'Moss Green'},       {code:'9006', name:'White Aluminium'},
    {code:'9010', name:'Pure White'},       {code:'1036', name:'Pearl Gold'},
    {code:'8017', name:'Chocolate Brown'}
  ];

  // Builds the swatch buttons once per configurator and keeps the text input
  // as the source of truth, so typing a RAL and clicking one stay consistent.
  function buildRalGrid(root){
    var grid = root.querySelector('[data-cfg="ralpick"]');
    var input = root.querySelector('[data-cfg="ral"]');
    if(!grid || !input || grid.childNodes.length) return;

    RAL_LIST.forEach(function(r){
      var label = 'RAL ' + r.code + ' ' + r.name;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ralpick__sw';
      b.style.background = RAL_HEX[r.code] || '#888';
      b.title = label;
      b.setAttribute('aria-label', label);
      b.setAttribute('data-ral', label);
      grid.appendChild(b);
    });

    grid.addEventListener('click', function(e){
      var b = e.target.closest('[data-ral]'); if(!b) return;
      input.value = b.getAttribute('data-ral');
      paintConfig(root);          // repaint price, swatch and selected state
    });
  }
  // Reflect the current value back onto the grid.
  function paintRalGrid(root, ral){
    var cur = (ral || '').match(/(\d{4})/);
    root.querySelectorAll('[data-cfg="ralpick"] [data-ral]').forEach(function(b){
      var on = !!cur && b.getAttribute('data-ral').indexOf(cur[1]) >= 0;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-config]').forEach(function(root){
    // The configurator only exists on a product page, so this is the one
    // reliable signal that a specific model is being viewed.
    var vcCode = root.getAttribute('data-config');
    if(CATALOG[vcCode]) track('viewContent', {code:vcCode, name:CATALOG[vcCode].name, price:CATALOG[vcCode].price, qty:1});

    buildRalGrid(root);

    // qty stepper
    var dec = root.querySelector('[data-cfg="qtydec"]'), inc = root.querySelector('[data-cfg="qtyinc"]'), qv = root.querySelector('[data-cfg="qtyval"]');
    function setQ(n){ if(qv){ qv.textContent = Math.max(1,n); paintConfig(root); } }
    if(dec) dec.addEventListener('click', function(){ setQ((parseInt(qv.textContent,10)||1)-1); });
    if(inc) inc.addEventListener('click', function(){ setQ((parseInt(qv.textContent,10)||1)+1); });
    // finish + ral + engraving
    root.querySelectorAll('input[name="cfgFinish"]').forEach(function(r){ r.addEventListener('change', function(){ paintConfig(root); }); });
    var ral = root.querySelector('[data-cfg="ral"]'); if(ral) ral.addEventListener('input', function(){ paintConfig(root); });
    /* The logo. There is no upload step any more: the file input is a
       real line-item property on a real Shopify product form, so the
       artwork travels with the add-to-cart and lands on the order in
       the admin. All this does is name the chosen file. */
    var fileInput = root.querySelector('[data-cfg="logo"]');
    var drop = root.querySelector('.filedrop');
    if(fileInput && drop){
      var ft = drop.querySelector('.ft');
      var setLabel = function(txt){ if(ft) ft.textContent = txt; };
      fileInput.addEventListener('change', function(){
        var file = fileInput.files && fileInput.files[0];
        if(!file){
          root.setAttribute('data-logo', '');
          drop.classList.remove('has-file');
          setLabel(MM_I18N.t('sd0edbb20') || 'Upload your logo or crest');
          return;
        }
        root.setAttribute('data-logo', file.name);
        drop.classList.add('has-file');
        setLabel(file.name);
      });
    }

    /* Add to cart. The button is a real submit, so with scripting off
       the form posts to /cart/add and the buyer still gets their cradle
       in the cart. With scripting on we intercept, post the same form
       to /cart/add.js, and stay on the page. */
    root.addEventListener('submit', function(e){
      e.preventDefault();
      var cfg = readConfig(root);
      var btn = root.querySelector('[data-cfg="add"]');
      var prev = btn ? btn.innerHTML : '';
      if(btn){ btn.setAttribute('disabled',''); btn.setAttribute('aria-busy','true'); }
      addFromForm(root).then(function(){
        trackAdd(cfg);
        toast(MM_I18N.t('js.addedToast')
                .replace('{name}', CATALOG[cfg.code].name + (cfg.coating?' · '+MM_I18N.t('js.customFinish'):''))
                .replace('{url}', ROUTES.cart));
      }).catch(function(err){
        toast(esc(err.message));
        if(window.console) console.error(err);
      }).then(function(){
        if(btn){ btn.innerHTML = prev; btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
      });
    });

    // request quote with this configuration
    var quote = root.querySelector('[data-cfg="quote"]');
    if(quote) quote.addEventListener('click', function(e){
      e.preventDefault();
      var cfg = readConfig(root);
      var q = ROUTES.quote + '?model='+encodeURIComponent(cfg.code)+'&qty='+cfg.qty+
              '&finish='+(cfg.coating?'custom':'standard')+
              (cfg.ral?('&ral='+encodeURIComponent(cfg.ral)):'')+
              (cfg.engraving?('&engraving='+encodeURIComponent(cfg.engraving)):'')+
              (cfg.logo?('&logo='+encodeURIComponent(cfg.logo)):'');
      window.location.href = q;
    });

    var buynow = root.querySelector('[data-cfg="buynow"]');
    if(buynow) buynow.addEventListener('click', function(){
      var cfg = readConfig(root);
      buynow.setAttribute('disabled',''); buynow.setAttribute('aria-busy','true');
      addFromForm(root).then(function(){
        trackAdd(cfg);
        startCheckout(buynow);
      }).catch(function(err){
        buynow.removeAttribute('disabled'); buynow.removeAttribute('aria-busy');
        toast(esc(err.message));
      });
    });

    paintConfig(root);
    configRoots.push(root);
  });

  /* ---- prefill the quote form from a configuration (?model=…&finish=…) ---- */
  (function(){
    var form = document.getElementById('quoteForm'); if(!form || !window.location.search) return;
    var p = new URLSearchParams(window.location.search);

    // Sent here from the cart when we have no shipping rate for the buyer's
    // country. Carrying it over means they do not type it twice, and the
    // country is the one thing this particular quote is about.
    var qc = form.querySelector('#q-country');
    if(qc && !qc.value && p.get('country')) qc.value = p.get('country').slice(0, 80);

    var modelMap = {L:'MagnuMaster L', XL:'MagnuMaster XL', XXL:'MagnuMaster XXL'};
    var model = p.get('model');
    if(model && modelMap[model]){
      var sel = form.querySelector('#q-model');
      if(sel) for(var i=0;i<sel.options.length;i++){ if(sel.options[i].value===modelMap[model]) sel.selectedIndex=i; }
    }
    /* Shopify's contact form keeps only the last value for a repeated
       field name, so the three personalisation boxes each carry their
       own contact[…] name and are found by a data attribute instead. */
    var checks=[];
    if(p.get('finish')==='custom'){ checks.push('Custom powder-coating'); }
    if(p.get('engraving')||p.get('logo')){ checks.push('Bespoke engraving'); }
    form.querySelectorAll('[data-personalisation]').forEach(function(cb){ if(checks.indexOf(cb.value)>=0) cb.checked=true; });
    // build a configuration summary into the message
    var msg = form.querySelector('#q-msg');
    if(msg && model && modelMap[model]){
      var lines = ['Configuration request — '+modelMap[model]+' × '+(p.get('qty')||'1')+':'];
      var codeFor = {'MagnuMaster L':'L','MagnuMaster XL':'XL','MagnuMaster XXL':'XXL'}[modelMap[model]] || model;
      lines.push('• Finish: ' + (p.get('finish')==='custom' ? ('Custom powder-coating'+(p.get('ral')?(' (RAL '+p.get('ral').replace(/ral/i,'').trim()+')'):'')+' — +'+euro(coatingOf(codeFor))) : 'Standard finish (Anthracite with iron glimmer)'));
      lines.push('• Engraving: ' + (p.get('engraving') ? ('“'+p.get('engraving')+'” (included)') : 'Included — text to follow'));
      if(p.get('logo')) lines.push('• Logo artwork: ' + p.get('logo'));
      msg.value = lines.join('\n') + '\n\n';
    }
    // surface a visible config banner if present
    var banner = document.getElementById('quoteConfig');
    if(banner && model && modelMap[model]){ banner.hidden = false; var b=banner.querySelector('[data-cfgline]'); if(b) b.textContent = modelMap[model] + ' · ' + (p.get('finish')==='custom'?('custom coating (+'+euro(coatingOf(model))+')'):'standard finish') + (p.get('engraving')?' · engraved':'') + ' · qty '+(p.get('qty')||'1'); }
  })();

  /* ---- quote form: reveal RAL / logo fields from the personalisation checks + logo upload ---- */
  (function(){
    var form = document.getElementById('quoteForm'); if(!form) return;
    var ralField = document.getElementById('q-coating');
    var logoField = document.getElementById('q-logo');
    var ralInput = document.getElementById('q-ral');
    // prefill the RAL box from a configuration link (?ral=…). The field lives
    // behind the custom-coating checkbox, so tick it too or the prefilled colour
    // is set but invisible.
    var pr = new URLSearchParams(window.location.search).get('ral');
    if(ralInput && pr){
      ralInput.value = pr;
      var coatCb = form.querySelector('[data-personalisation][value="Custom powder-coating"]');
      if(coatCb) coatCb.checked = true;
    }
    function sync(){
      var on = {};
      form.querySelectorAll('[data-personalisation]').forEach(function(cb){ if(cb.checked) on[cb.value] = true; });
      if(ralField) ralField.hidden = !on['Custom powder-coating'];
      if(logoField) logoField.hidden = !on['Bespoke engraving'];
    }
    form.querySelectorAll('[data-personalisation]').forEach(function(cb){ cb.addEventListener('change', sync); });
    sync();

    /* Artwork on the quote form — three steps, unchanged from the
       static site because Shopify's upload flow has not changed:

         1. ask api/upload-logo.js to stage an upload; it answers with a
            signed Google Cloud Storage URL and the parameters that go
            with it;
         2. POST the file straight to that URL — the bytes never touch
            our server;
         3. ask api/upload-logo.js to register the uploaded object as a
            permanent file in Content → Files, and hand back its CDN URL.

       That URL rides on the draft order, so the client opens the
       artwork from the order rather than hunting through an inbox.

       The whole block only exists when the endpoint is configured; the
       markup otherwise renders a line asking for the file by reply. On
       the product page none of this applies — there, Shopify takes the
       file natively as a line-item property. */
    var fileInput = logoField ? logoField.querySelector('input[type="file"]') : null;
    var nameField = form.querySelector('[data-quote-logo-name]');
    var urlField = form.querySelector('[data-quote-logo-url]');

    function stageAndUpload(file){
      var mime = file.type || 'application/octet-stream';
      return fetch(SHOP.uploadEndpoint, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({action:'stage', filename:file.name, mimeType:mime, fileSize:String(file.size)})
      }).then(function(r){
        return r.json().catch(function(){ return {}; }).then(function(j){
          if(!r.ok) throw new Error(j.error || ('Upload could not be prepared (HTTP ' + r.status + ').'));
          return j;
        });
      }).then(function(staged){
        // Shopify's staged target wants its own parameters before the file.
        var fd = new FormData();
        (staged.parameters || []).forEach(function(prm){ fd.append(prm.name, prm.value); });
        fd.append('file', file);
        return fetch(staged.url, {method:'POST', body:fd}).then(function(r){
          if(!r.ok) throw new Error('Upload to Shopify failed (HTTP ' + r.status + ').');
          return staged;
        });
      }).then(function(staged){
        return fetch(SHOP.uploadEndpoint, {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({action:'finalize', resourceUrl:staged.resourceUrl, filename:file.name, mimeType:mime})
        }).then(function(r){
          return r.json().catch(function(){ return {}; }).then(function(j){
            if(!r.ok) throw new Error(j.error || 'Could not save the file to Shopify.');
            return j.url || staged.resourceUrl;
          });
        });
      });
    }

    if(fileInput && SHOP.uploadEndpoint){
      var ft = logoField.querySelector('.ft');
      var setLabel = function(t){ if(ft) ft.textContent = t; };
      fileInput.addEventListener('change', function(){
        var file = fileInput.files && fileInput.files[0];
        if(urlField) urlField.value = '';
        if(!file){
          if(nameField) nameField.value = '';
          form.removeAttribute('data-logo');
          logoField.classList.remove('has-file');
          setLabel(MM_I18N.t('sd0edbb20') || 'Upload your logo or crest');
          return;
        }
        // The filename is recorded before the upload is attempted, and is
        // never cleared by a failure: it is what tells the client which
        // artwork to chase, and it travels on the draft order either way.
        if(nameField) nameField.value = file.name;
        form.setAttribute('data-logo', file.name);
        logoField.classList.add('has-file');

        if(file.size > 20 * 1024 * 1024){
          setLabel(file.name + ' · too large (20 MB max) — please send it by email');
          return;
        }

        setLabel('Uploading ' + file.name + '…');
        stageAndUpload(file).then(function(url){
          if(urlField) urlField.value = url;
          setLabel(file.name + ' · uploaded');
        }).catch(function(err){
          // The enquiry still sends, and the filename still rides along,
          // so the order is workable even when the upload was not.
          setLabel(file.name + ' · upload failed, we will email you for the artwork');
          if(window.console) console.warn('Logo upload failed:', err.message);
        });
      });
    }
  })();

  /* ============================================================
     THE QUOTE FORM — a draft order, with email as the safety net.
     ------------------------------------------------------------
     A quote request becomes a real draft order in Orders → Drafts,
     priced against the right variant, carrying the finish, RAL colour,
     engraving text, bottle format, company and VAT ID. That needs the
     Admin API, which needs a server, which is why api/quote.js is still
     deployed. MM_SHOP.quoteEndpoint is where it lives.

     What is new is the failure path. The markup is Shopify's own
     contact form, so if the draft-order call fails — the function is
     cold, the deploy is down, the visitor is on hotel wifi — we stop
     intercepting and let the browser submit the form natively. The
     enquiry then arrives as email instead of as a draft. A quote
     request is a sales lead; it is never dropped because a serverless
     function had a bad afternoon.

     With no endpoint configured, nothing is intercepted at all and the
     form is simply a contact form.
     ============================================================ */
  (function(){
    var form = document.getElementById('quoteForm'); if(!form) return;

    form.querySelectorAll('input,select,textarea').forEach(function(f){
      f.addEventListener('input', function(){ var fld=f.closest('.field'); if(fld) fld.classList.remove('bad'); });
    });

    var val = function(id){ var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; };

    /* Built from ids, not from field names: the inputs are named
       contact[…] so the fallback email reads properly, and the draft
       order wants its own shape. Kept in step with api/quote.js. */
    function payload(){
      var p = new URLSearchParams(window.location.search);
      var personalisation = [];
      form.querySelectorAll('[data-personalisation]').forEach(function(cb){
        if(cb.checked) personalisation.push(cb.value);
      });
      var urlField = form.querySelector('[data-quote-logo-url]');
      return {
        name: val('q-name'),
        email: val('q-email'),
        phone: val('q-phone'),
        country: val('q-country'),
        companyName: val('q-companyname'),
        vatId: val('q-vat'),
        model: val('q-model'),
        format: val('q-format'),
        message: val('q-msg'),
        personalisation: personalisation,
        // What the buyer typed wins; a configuration link (?ral=…&logo=…)
        // fills the gaps when the quote came from a product page.
        ral: val('q-ral') || p.get('ral') || '',
        engraving: p.get('engraving') || '',
        logo: form.getAttribute('data-logo') || p.get('logo') || '',
        logoUrl: urlField ? urlField.value : '',
        qty: parseInt(p.get('qty'), 10) || 1,
        language: getLang(),
        attribution: attribution(),
        // The honeypot. api/quote.js answers 200 and does nothing when
        // it is filled, so a bot never learns it was caught.
        fax: (form.querySelector('.honey input') || {}).value || ''
      };
    }

    function showSuccess(){
      var panel = document.getElementById('quoteDone');
      form.style.display = 'none';
      if(panel){
        panel.classList.add('show');
        panel.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'center'});
      }
    }

    form.addEventListener('submit', function(e){
      var ok = true;
      form.querySelectorAll('[required]').forEach(function(f){
        var v = (f.value||'').trim();
        var bad = !v || (f.type==='email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v));
        var fld = f.closest('.field'); if(fld) fld.classList.toggle('bad', bad);
        if(bad) ok = false;
      });
      if(!ok){
        e.preventDefault();
        var firstBad = form.querySelector('.field.bad input,.field.bad select,.field.bad textarea');
        if(firstBad) firstBad.focus();
        toast(MM_I18N.t('js.fillFields'));
        return;
      }

      // No endpoint: let Shopify have it. The contact form is the whole
      // mechanism in that configuration, not a fallback.
      if(!SHOP.quoteEndpoint) return;

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var prev = btn ? btn.innerHTML : '';
      if(btn){ btn.innerHTML = '<span data-i18n="js.sending">' + MM_I18N.t('js.sending') + '</span>'; btn.setAttribute('disabled',''); }

      var body = payload();

      fetch(SHOP.quoteEndpoint, {
        method: 'POST',
        headers: {'Content-Type':'application/json', 'Accept':'application/json'},
        body: JSON.stringify(body)
      }).then(function(r){
        return r.json().catch(function(){ return {}; }).then(function(j){
          if(!r.ok){
            var e = new Error(j.error || ('HTTP ' + r.status));
            e.status = r.status;
            throw e;
          }
          return j;
        });
      }).then(function(){
        // Only a request the server actually recorded counts as a Lead.
        /* Same advanced-matching data as the source page — see the note in
           js/main.js. The theme posts the quote as body, so read it there. */
        track('lead', {
          name: 'Quote request',
          model: body.model || 'unspecified',
          user: {
            name:    body.name    || '',
            email:   body.email   || '',
            phone:   body.phone   || '',
            country: body.country || ''
          }
        });
        showSuccess();
      }).catch(function(err){
        /* A 400 means the server disagreed with something the buyer
           typed — an address our regex accepted and its own did not, say.
           They can fix that, so tell them and hand the form back rather
           than silently posting it somewhere else. */
        if(err.status === 400){
          if(btn){ btn.innerHTML = prev; btn.removeAttribute('disabled'); }
          toast(esc(err.message));
          return;
        }

        /* Anything else — the function is cold, the deploy is down, the
           rate limit tripped, the visitor is on hotel wifi — is not the
           buyer's problem and not something they can act on. Rather than
           showing an error and losing the lead, submit the same form to
           Shopify: the enquiry arrives as email, the buyer sees the
           normal thank-you page, and the client follows up by hand.
           form.submit() does not fire this listener again, so there is
           no loop. */
        if(window.console) console.warn('Draft order failed, falling back to the contact form:', err.message);
        form.submit();
      });
    });
  })();

  /* Scroll a returning buyer to the thank-you panel Liquid rendered —
     the fallback path lands back here with ?contact_posted=true. */
  (function(){
    var done = document.getElementById('quoteDone');
    if(done && done.classList.contains('show')){
      done.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'center'});
      var f = document.getElementById('quoteForm');
      if(f) f.style.display = 'none';
    }
  })();

  /* The journal used to live here: ~200 lines that fetched /posts and
     /posts/:slug from the CMS, painted them with innerHTML, and rewrote
     the page's own <title>, description and canonical afterwards so that
     twenty articles were not all indexed as post.html.

     None of it survives the move, and none of it is missed. An article is
     a page now — sections/main-article.liquid — with its own URL, its own
     <head> and its own structured data, rendered server-side.

     The CMS keeps the job it is genuinely good at: the translated copy
     behind every data-i18n key on the site. */


  updateStoreUI();
  guessShipCountry();

  (function(){
    function makeLangSw(){
      var sw = document.createElement('div'); sw.className = 'lang-sw';
      LANGS.forEach(function(l){
        var b = document.createElement('button'); b.className = 'lang-btn'; b.setAttribute('data-lang', l);
        b.textContent = l.toUpperCase();
        b.addEventListener('click', function(){ setLang(l); });
        sw.appendChild(b);
      });
      return sw;
    }
    var navRight = document.querySelector('.nav__right');
    var burger = navRight ? navRight.querySelector('.burger') : null;
    if(navRight && !navRight.querySelector('.lang-sw')){
      var desktopSw = makeLangSw(); desktopSw.classList.add('lang-sw--desktop');
      if(burger){ navRight.insertBefore(desktopSw, burger); } else { navRight.appendChild(desktopSw); }
    }
    var menuFoot = document.querySelector('.menu__foot');
    if(menuFoot && !menuFoot.querySelector('.lang-sw')){
      var mobileSw = makeLangSw(); mobileSw.classList.add('lang-sw--mobile');
      var mobileWrap = document.createElement('div'); mobileWrap.className = 'menu__lang';
      // A caption above the row. Seven bare language codes in a pill are not
      // self-evident as a language chooser on a phone, where this is the only
      // way to switch — so it gets a label, translated like everything else.
      var label = document.createElement('span');
      label.className = 'lang-label';
      label.setAttribute('data-i18n', 'menu.language');
      label.textContent = DICT.en['menu.language'] || 'Language';
      mobileWrap.appendChild(label);
      mobileWrap.appendChild(mobileSw);
      menuFoot.appendChild(mobileWrap);
    }
  })();
  seedEnglish();

  /* Pictures are language-independent, so this runs once at boot rather than
     on every language change. It never blocks the paint. */
  applyImages();

  /* ---- pick the language ---------------------------------------------------
     Precedence: an explicit click always wins; then the visitor's country; then
     the browser language; then English. The country lookup is a network call,
     so we paint the browser's guess immediately and repaint if the country
     disagrees — the page is never blank or blocked waiting on it. */
  (function(){
    var chosen = chosenLang();
    if(chosen){ applyLang(chosen); return; }        // their choice, no guessing, no bar

    var guess = browserLang() || 'en';
    applyLang(guess);

    country().then(function(cc){
      var pick = (cc && GEO_LANG[cc]) || browserLang() || 'en';
      // Not persisted to LANG_KEY on purpose — a guess must never masquerade
      // as a choice, or the switcher's "active" state lies on the next visit.
      var done = pick === curLang ? Promise.resolve() : applyLang(pick);
      if(pick !== 'en') done.then(function(){ langNote(pick); });
    });
  })();

  /* Auto-switching is a guess, and Italian, Spanish, French, Portuguese and Dutch are machine
     translated — so an auto-switched visitor always gets a one-click way back
     to English rather than a dead end. The escape hatch is worded in English so
     it stays readable to someone who can't read the language we just guessed. */
  var NOTE_KEY = 'mm_langnote';
  function langNote(lang){
    var COPY = {
      de:'Sie sehen diese Seite auf Deutsch.',
      it:'Sta visualizzando questa pagina in italiano.',
      es:'Está viendo esta página en español.',
      fr:'Vous consultez cette page en français.',
      pt:'Está a ver esta página em português.',
      nl:'U bekijkt deze pagina in het Nederlands.'
    };
    if(!COPY[lang]) return;
    try{ if(sessionStorage.getItem(NOTE_KEY)) return; }catch(e){}
    if(document.querySelector('.langnote')) return;

    function show(){
      var el = document.createElement('div');
      el.className = 'langnote';
      el.setAttribute('role', 'status');
      el.innerHTML =
        '<span class="langnote__txt">' + COPY[lang] + '</span>' +
        '<button type="button" class="langnote__btn" data-langnote="en">Switch to English</button>' +
        '<button type="button" class="langnote__x" data-langnote="close" aria-label="'+MM_I18N.t('aria.dismiss')+'">&times;</button>';
      el.addEventListener('click', function(e){
        var btn = e.target.closest('[data-langnote]');
        if(!btn) return;
        try{ sessionStorage.setItem(NOTE_KEY, '1'); }catch(e){}
        if(btn.getAttribute('data-langnote') === 'en') setLang('en');   // now it IS a choice
        el.classList.remove('show');
        setTimeout(function(){ el.remove(); }, 500);
      });
      document.body.appendChild(el);
      requestAnimationFrame(function(){ el.classList.add('show'); });
    }

    // Both this and the cookie banner dock at the bottom of the screen, and
    // consent is the more urgent of the two — so queue behind it.
    if(document.querySelector('.cookie')){
      document.body.addEventListener('mm:consent-closed', show, {once:true});
    } else show();
  }

  var SEARCH_INDEX = [
    {title:'MagnuMaster L', desc:'Decanting cradle for bottles from 0.75 to 6 litres — compact, precise.', url:'/products/magnumaster-l', kw:'l small compact magnum double 0.75 1.5 3 4.5 6 bottle price preis kaufen buy order 2580'},
    {title:'MagnuMaster XL', desc:'The most-chosen model — best all-rounder for 3 to 18 litres.', url:'/products/magnumaster-xl', kw:'xl all-rounder most chosen jeroboam methuselah 3 9 12 15 18 litre price preis kaufen buy order 3300'},
    {title:'MagnuMaster XXL', desc:'For very large formats — 4.5 to 30 litres, maximum stability.', url:'/products/magnumaster-xxl', kw:'xxl large balthazar nebuchadnezzar melchior goliath melchizedek 18 26 30 price preis kaufen buy order 9500'},
    {title:'Shop the Collection', desc:'Order your MagnuMaster — view all models and pricing.', url:'/collections/magnumaster', kw:'shop buy order price pricing kaufen preis bestellen warenkorb cart'},
    {title:'Compare Models', desc:'Side-by-side comparison of L, XL and XXL.', url:'/pages/compare', kw:'compare comparison difference which model choose size'},
    {title:'About & Story', desc:'The people and workshop behind MagnuMaster — made in Tyrol since 2011.', url:'/pages/about', kw:'about story history tyrol tirol austria österreich craftsman workshop team people mathias laurin koidl peter sturm manfred kronen blacksmith geschichte über uns'},
    {title:'Engineering', desc:'How the dual-pivot mechanism works — precision pouring explained.', url:'/#mechanism', kw:'engineering mechanism how works pivot pour aeration sediment'},
    {title:'Engraving & Custom Coating', desc:'Bespoke personalisation — engraving included, RAL powder-coating from +€550.', url:'/pages/engraving', kw:'engraving personalisation custom coating ral colour logo branding'},
    {title:'RAL Colour Gallery', desc:'Browse available RAL colours for custom powder-coating.', url:'/pages/ral-colours', kw:'ral colour color paint coating finish'},
    {title:'Hospitality & Restaurants', desc:'MagnuMaster for restaurants, hotels and sommeliers.', url:'/pages/hospitality', kw:'hospitality restaurant hotel sommelier michelin service'},
    {title:'Collector & Gift', desc:'MagnuMaster as a collector\'s centrepiece or unforgettable gift.', url:'/pages/gift', kw:'gift collector cellar present birthday christmas'},
    {title:'How to Serve Large-Format Wine', desc:'Guide to decanting and serving magnums and larger bottles.', url:'/pages/serve-large-format-wine', kw:'how decant serve large format wine guide tips'},
    {title:'FAQ', desc:'Frequently asked questions about MagnuMaster.', url:'/pages/faq', kw:'faq questions delivery shipping warranty support fragen lieferung versand garantie hilfe'},
    {title:'Request a Quote', desc:'Get a personalised quote for your MagnuMaster configuration.', url:'/pages/request-a-quote', kw:'quote request contact order enquiry angebot anfrage kontakt email phone telefon vat uid company firma'},
    {title:'Blog / Journal', desc:'Wine, craft and large-format serving — from the MagnuMaster team.', url:'/blogs/journal', kw:'blog journal article news wine'},
    {title:'Press & Partners', desc:'Media coverage and partner logos.', url:'/pages/press', kw:'press media partners clients riedel swarovski hilton raffles rosewood waldorf dorchester'},
    {title:'Bottle Formats', desc:'Every large format from magnum to the 30-litre Melchizedek, and the cradle for each.', url:'/pages/formats', kw:'formats sizes magnum jeroboam methuselah salmanazar balthazar nebuchadnezzar melchior goliath melchizedek litre liter flaschengrößen'},
    {title:'Imprint', desc:'Company details, legal information and contact.', url:'/pages/imprint', kw:'imprint impressum legal company details contact address koidl offenlegung ecg firmenbuch'},
    {title:'Privacy Policy', desc:'How we collect, use and protect your personal data.', url:'/pages/privacy', kw:'privacy datenschutz gdpr dsgvo data cookies tracking'},
    {title:'Terms & Conditions', desc:'General terms and conditions of sale.', url:'/pages/terms', kw:'terms conditions agb gtc legal sale'},
    {title:'Purchase & Returns', desc:'Ordering, delivery, cancellation and returns.', url:'/pages/purchase-returns', kw:'purchase returns delivery shipping cancellation refund widerruf rückgabe versand'}
  ];
  /* Match on every word the visitor typed, in any order and any field, so
     "koidl imprint" or "xl price" work. The old single-substring match only
     ever matched one contiguous run of text. */
  function searchIndex(q){
    var terms = (q||'').toLowerCase().trim().split(/\s+/).filter(Boolean);
    if(!terms.length) return [];
    return SEARCH_INDEX.filter(function(r){
      var hay = (r.title+' '+r.desc+' '+r.kw).toLowerCase();
      return terms.every(function(t){ return hay.indexOf(t) >= 0; });
    });
  }
  var searchOverlay = null;
  function openSearch(){
    if(!searchOverlay){
      searchOverlay = document.createElement('div'); searchOverlay.className = 'search-overlay'; searchOverlay.setAttribute('role','dialog'); searchOverlay.setAttribute('aria-label','Search');
      var closeBtn = document.createElement('button'); closeBtn.className = 'search-close'; closeBtn.setAttribute('aria-label','Close search');
      closeBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      closeBtn.addEventListener('click', closeSearch);
      var wrap = document.createElement('div'); wrap.className = 'search-wrap';
      var inp = document.createElement('input'); inp.className = 'search-input'; inp.type = 'text'; inp.placeholder = 'Search MagnuMaster…'; inp.setAttribute('autocomplete','off'); inp.setAttribute('spellcheck','false');
      var results = document.createElement('ul'); results.className = 'search-results';
      /* Enter hands anything to Shopify's own search, which knows about
         products, pages and journal entries written after this theme was
         deployed — the built-in index below only knows the pages that
         existed when it was written. */
      inp.addEventListener('keydown', function(e){
        if(e.key !== 'Enter') return;
        var q = inp.value.trim();
        if(q) window.location.href = '/search?q=' + encodeURIComponent(q);
      });
      inp.addEventListener('input', function(){
        var q = inp.value; var hits = searchIndex(q); results.innerHTML = '';
        if(q && !hits.length){
          var em = document.createElement('li'); em.className = 'search-empty';
          em.innerHTML = MM_I18N.t('js.noQuickMatch').replace('{q}', esc(q)) +
            ' <a href="/search?q=' + encodeURIComponent(q) + '">' + MM_I18N.t('js.searchAll') + ' →</a>';
          results.appendChild(em); return;
        }
        hits.forEach(function(r){
          var li = document.createElement('li'); li.className = 'search-result';
          li.innerHTML = '<a href="'+r.url+'"><div class="sr-title">'+r.title+'</div><div class="sr-desc">'+r.desc+'</div></a>';
          results.appendChild(li);
        });
      });
      wrap.appendChild(inp); searchOverlay.appendChild(closeBtn); searchOverlay.appendChild(wrap); searchOverlay.appendChild(results);
      document.body.appendChild(searchOverlay);
      searchOverlay.addEventListener('click', function(e){ if(e.target === searchOverlay) closeSearch(); });
    }
    searchOverlay.classList.add('open'); document.body.style.overflow = 'hidden';
    setTimeout(function(){ searchOverlay.querySelector('.search-input').focus(); }, 100);
  }
  function closeSearch(){ if(searchOverlay){ searchOverlay.classList.remove('open'); document.body.style.overflow = ''; } }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('open')) closeSearch();
    if((e.key === 'k' || e.key === 'K') && (e.ctrlKey || e.metaKey)){ e.preventDefault(); openSearch(); }
  });
  (function(){
    var navRight = document.querySelector('.nav__right');
    var burger = navRight ? navRight.querySelector('.burger') : null;
    if(navRight && !navRight.querySelector('.nav__search')){
      var searchBtn = document.createElement('button'); searchBtn.className = 'nav__search'; searchBtn.setAttribute('aria-label','Search'); searchBtn.title = 'Search (Ctrl+K)';
      searchBtn.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>';
      searchBtn.addEventListener('click', openSearch);
      if(burger){ navRight.insertBefore(searchBtn, burger); } else { navRight.appendChild(searchBtn); }
    }
  })();
})();
